<template>
  <v-container grid-list-md class="py-0 px-2 ma-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0">
            <v-layout row wrap>
              <v-flex xs10>
                <v-text-field
                class="pa-0 mt-1"
                append-icon="mdi-account-search-outline"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search Month-Year':'Search'"
                single-line
                hide-details
                v-model="search"
                @input="searchMonthYearTitle(search)"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-expansion-panels v-if="yearList.length > 0" :value="selTab">
              <v-expansion-panel v-for="(payrollYear, i) in yearList" :key="i">
                <v-expansion-panel-header class=" grey lighten-2">
                  <div class="subtitle">{{ payrollYear }}</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                  :headers="payrollProcessSummaryHead"
                  :items="lPayrollProcessSummaryList.filter(rec => rec.payrollYear === payrollYear)"
                  hide-default-footer
                  dense
                  disable-pagination
                  :mobile-breakpoint="0"
                  class="elevation-1 pt-2"
                  >
                    <template slot="item" slot-scope="props">
                      <tr @click="prepareUpdate(props.item)" :class="">
                        <td style="font-size: 12px; text-align: center;">{{ props.index + 1 }}</td>
                        <td style="font-size: 12px; text-align: center;">{{ props.item.payroll_month_year }}</td>
                        <td style="font-size: 12px; text-align: center;">{{ props.item.base_version_text }}</td>
                        <td style="font-size: 12px; text-align: center;">{{ props.item.base_status }}</td>
                        <td style="font-size: 12px; text-align: center;">{{ props.item.month_days }}</td>
                        <td style="font-size: 12px;">{{ props.item.base_remarks }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-flex xs12 v-else>
              <div style="font-size: 15px; text-align: center; color: #FFAB40;">
                No Active Payroll Process
              </div>
            </v-flex>
          </v-card-text>
        </v-card>

        <!-- 1. Create / update payroll processing base -->
        <v-dialog v-model="showCreatePayrollProcessBase" persistent scrollable max-width="600px">
          <v-form ref="pForm" @submit.prevent="savePayrollProcessBase(lAction)">
            <v-card>
              <v-card-title class="py-2 grey lighten-4">
                {{ handy.startWithUpper(lAction) }} Payroll Process Base
              </v-card-title>
              <v-card-text class="pt-0 pb-2">
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs4 class="pl-1">
                      <v-dialog ref="dlgPayrollProcessMon"
                      persistent v-model="dlgPayrollProcessMon"
                      max-width="290px"
                      :return-value.sync="lPayrollProcessBase.payroll_month_year"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="Month &amp; Year"
                          :rules="[rules.required]"
                          v-model="lPayrollProcessBase.payroll_month_year" append-icon="mdi-calendar-today"
                          readonly clearable hide-details
                          v-on="on"
                          style="font-size: 14px"
                          ></v-text-field>
                        </template>
                        <v-date-picker type="month"
                        @input="loadExistingPayrollProcessifAnyforSelectedMonthYear(lPayrollProcessBase.payroll_month_year)"
                        v-model="lPayrollProcessBase.payroll_month_year" scrollable
                        first-day-of-week="1"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text @click="dlgPayrollProcessMon = false">Cancel</v-btn>
                          <v-btn text color="accent" @click="$refs.dlgPayrollProcessMon.save(lPayrollProcessBase.payroll_month_year)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs3 class="pt-5">
                      <div class="text-center font-weight-bold"> Days in Month : <span class="blue--text"> {{lPayrollProcessBase.month_days}}</span></div>
                    </v-flex>
                    <v-flex xs2 class="pt-5">
                      <div class="text-center font-weight-bold"> Version : <span class="blue--text">{{lPayrollProcessBase.base_version}}</span></div>
                    </v-flex>
                    <v-flex xs3  class="pt-5">
                      <div class="text-center font-weight-bold"> Status : <span class="blue--text">{{lPayrollProcessBase.base_status}}</span></div>
                    </v-flex>
                    <v-flex xs12 class="pt-3" v-if="payrollBaseAlreadyExists">
                      <div class="font-weight-bold white--text" style="background-color:red; text-align:center; font-size: 14px">Payroll Process already created for selected Month and Year. <br /> Please use the existing record.</div>
                    </v-flex>
                    <v-flex xs3 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessBase.ESI_percent_employee"
                      label="ESI % - Employee"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessBase.ESI_percent_employer"
                      label="ESI % - Employer"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessBase.PF_percent_employee"
                      label="PF % - Employee"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessBase.PF_percent_employer"
                      label="PF % - Employer"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessBase.PF_restrict_limit_employee"
                      label="PF Restriction Limit Amount - Employee"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessBase.PF_restrict_limit_employer"
                      label="PF Restriction Limit Amount - Employer"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessBase.professional_tax_amt"
                      label="Professional Tax Amount in Rs."
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessBase.prof_ser_tds_percent"
                      label="Professional Service TDS %"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessBase.pt_limit_amt"
                      label="PT Limit Amount"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessBase.pt_eligible_ref_amt"
                      label="PT Eligible Amount for Reference"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessBase.base_remarks"
                      label="Remarks (if any)"
                      style="font-size: 14px"
                      hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
              <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
                <v-btn small @click="closePayrollProcessDialog()">close</v-btn>
                <v-btn small :disabled="payrollBaseAlreadyExists" class="accent" v-if="config.IS_EDITED_BY_USER" type="submit">save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <!-- 2. payroll process det screen -->
        <v-container v-if="lAction === 'update'" class="pa-0" fluid full-height>
          <v-layout row wrap>
            <v-flex xs12 class="mt-2">
              <v-card>
                <v-card-title class="py-1 grey lighten-4">
                  <v-btn small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                  <span style="font-size: 17px" class="pl-2 primary--text">{{ handy.startWithUpper(lAction) + ' Payroll Process' }}</span>
                </v-card-title>
                <v-card-text>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs4>
                        <v-dialog ref="dlgPayrollProcessMon"
                        persistent v-model="dlgPayrollProcessMon"
                        max-width="290px"
                        :return-value.sync="lPayrollProcessBase.payroll_month_year"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Month &amp; Year"
                            :rules="[rules.required]"
                            v-model="lPayrollProcessBase.payroll_month_year" append-icon="mdi-calendar-today"
                            readonly clearable hide-details
                            v-on="on" :disabled="lAction === 'update'"
                            style="font-size: 12px"
                            ></v-text-field>
                          </template>
                          <v-date-picker type="month" :disabled="lAction === 'update'"
                          v-model="lPayrollProcessBase.payroll_month_year" scrollable
                          first-day-of-week="1"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text @click="dlgPayrollProcessMon = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.dlgPayrollProcessMon.save(lPayrollProcessBase.payroll_month_year)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs4>
                        <v-autocomplete
                        v-model="lPayrollProcessBase.base_version"
                        :items="payrollProcessVersionList"
                        item-text="base_version_text"
                        item-value="base_version"
                        label="Version"
                        style="font-size: 12px"
                        hide-details
                        @input="changePayrollProcessVersionList()"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs4 class="text-right pt-4">
                        <v-btn small class="mr-3" @click="deletePayrollProcessBase(lPayrollProcessBase)" :disabled="(payrollProcessDetailList.length != 0 && lAction === 'update') || (!config.IS_EDITED_BY_USER)">delete</v-btn>
                        <v-btn small class="info" @click="showPayrollProcessBaseInfo(lPayrollProcessBase)">Info</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 v-if="lPayrollProcessBase.payroll_process_base_id">
              <v-card>
                <v-card-title class="py-2 pl-2 grey lighten-4">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs3 class="text-center">
                        <v-text-field
                        v-model="searchPayrollProcessDetail"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        clearable
                        hide-details
                        style="font-size: 14px"
                        class="mt-0 pt-0"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs9 class="text-center">
                        <v-btn small style="font-size: 10px;" class="font-weight-bold accent mr-2" v-if="(config.IS_EDITED_BY_USER)" :disabled="(config.ROLE_NAME != 'Super Admin' && lPayrollProcessBase.base_status !== 'Draft')" @click="prepareAddEmployeeDetail()">Add Employee</v-btn>
                        <v-btn small style="font-size: 10px;" class="font-weight-bold accent mr-2" v-if="(config.IS_EDITED_BY_USER)" :disabled="(config.ROLE_NAME != 'Super Admin' && lPayrollProcessBase.base_status !== 'Draft')" @click="prepareImportPayrollDetail(lPayrollProcessBase.payroll_process_base_id)">Import EMP Details</v-btn>
                        <v-btn small style="font-size: 10px;" class="success font-weight-bold mr-2" v-if="(config.IS_EDITED_BY_USER)" :disabled="(config.ROLE_NAME != 'Super Admin' && lPayrollProcessBase.base_status !== 'Draft') || isProcessingPayroll" :loading="isProcessingPayroll" @click="bulkPayrollProcess(lPayrollProcessBase.payroll_process_base_id)">Process All Records</v-btn>
                        <v-btn small style="font-size: 9px;" class="info font-weight-bold" @click="showImportedProjectList(lPayrollProcessBase)">Remaining Projects</v-btn>
                        <v-download-as
                        :headers="payrollProcessDetailHeaders"
                        :items="payrollProcessDetailList"
                        :title="lPayrollProcessBase.payroll_month_year"
                        :fontsize="8"
                        :subtitle="'Payroll Processing - ' + lPayrollProcessBase.payroll_month_year"
                        :landscape="true"
                        ></v-download-as>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-title>
                <v-card-text class="pa-1">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12 class="pa-0">
                        <v-flex xs12>
                          <v-data-table
                          :headers="payrollProcessDetailHeaders"
                          :items="payrollProcessDetailList"
                          hide-default-footer
                          fixed-header
                          height="500px"
                          disable-pagination
                          dense
                          :search="searchPayrollProcessDetail"
                          loading
                          loading-text="Loading... Please wait"
                          >
                            <template slot="item" slot-scope="props">
                              <v-menu
                              absolute
                              offset-y
                              >
                                <template v-slot:activator="{ on }">
                                  <tr v-on="on">
                                    <td style="font-size: 12px; text-align: center; background-color: #F1F8E9">{{ props.index + 1 }}</td>
                                    <td style="font-size: 12px; text-align: center; background-color: #F1F8E9">{{ props.item.vendor_emp_id }}</td>
                                    <td style="font-size: 12px; text-align: left; background-color: #F1F8E9">{{ props.item.emp_name }}</td>
                                    <td style="font-size: 12px; text-align: left; background-color: #F1F8E9">{{ props.item.site_staff_role }}</td>
                                    <td style="font-size: 12px; text-align: left; background-color: #F1F8E9">{{ props.item.emp_desig }}</td>
                                    <td style="font-size: 12px; text-align: left; background-color: #F1F8E9">{{ props.item.proj_name }}</td>
                                    <td style="font-size: 12px; text-align: center; background-color: #F1F8E9">{{ props.item.payroll_cat }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #F1F8E9">{{ props.item.cust_budget_salary ? handy.formatNum(props.item.cust_budget_salary) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #F1F8E9">{{ props.item.cust_billing_salary ? handy.formatNum(props.item.cust_billing_salary) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #F1F8E9">{{ props.item.budget_takehome_salary ? handy.formatNum(props.item.budget_takehome_salary) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #DCEDC8">{{ props.item.fixedwages_basic ? handy.formatNum(props.item.fixedwages_basic) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #DCEDC8">{{ props.item.fixedwages_da ? handy.formatNum(props.item.fixedwages_da) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #DCEDC8">{{ props.item.fixedwages_hra ? handy.formatNum(props.item.fixedwages_hra) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #DCEDC8">{{ props.item.fixedwages_conveyance ? handy.formatNum(props.item.fixedwages_conveyance) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #DCEDC8">{{ props.item.fixedwages_washing ? handy.formatNum(props.item.fixedwages_washing) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #DCEDC8">{{ props.item.fixedwages_other_allowance ? handy.formatNum(props.item.fixedwages_other_allowance) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #DCEDC8">{{ props.item.fixedwages_leave_wages ? handy.formatNum(props.item.fixedwages_leave_wages) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #DCEDC8">{{ props.item.fixedwages_performincentive ? handy.formatNum(props.item.fixedwages_performincentive) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #DCEDC8">{{ props.item.fixedwages_bonus ? handy.formatNum(props.item.fixedwages_bonus) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #DCEDC8">{{ props.item.fixedwages_child_edu ? handy.formatNum(props.item.fixedwages_child_edu) : '-' }}</td>
                                    <td style="font-size: 13px; text-align: right; background-color: #DCEDC8"> <strong>{{ props.item.fixedwages_gross_salary ? handy.formatNum(props.item.fixedwages_gross_salary) : '-' }}</strong></td>
                                    <td style="font-size: 12px; text-align: center; background-color: #B2EBF2">{{ props.item.earnedwages_payroll_attendance ? handy.formatNum(props.item.earnedwages_payroll_attendance) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_basic ? handy.formatNum(props.item.earnedwages_basic) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_da ? handy.formatNum(props.item.earnedwages_da) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_hra ? handy.formatNum(props.item.earnedwages_hra) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_conveyance ? handy.formatNum(props.item.earnedwages_conveyance) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_washing ? handy.formatNum(props.item.earnedwages_washing) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_other_allowance ? handy.formatNum(props.item.earnedwages_other_allowance) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_leave_wages ? handy.formatNum(props.item.earnedwages_leave_wages) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_performincentive ? handy.formatNum(props.item.earnedwages_performincentive) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_bonus ? handy.formatNum(props.item.earnedwages_bonus) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_child_edu ? handy.formatNum(props.item.earnedwages_child_edu) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_adjust_amt ? handy.formatNum(props.item.earnedwages_adjust_amt) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_nfh ? handy.formatNum(props.item.earnedwages_nfh) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B2EBF2">{{ props.item.earnedwages_ot ? handy.formatNum(props.item.earnedwages_ot) : '-' }}</td>
                                    <td style="font-size: 13px; text-align: right; background-color: #B2EBF2"><strong>{{ props.item.earnedwages_gross_salary ? handy.formatNum(props.item.earnedwages_gross_salary) : '-' }}</strong></td>
                                    <td style="font-size: 12px; text-align: right; background-color: #FFF9C4">{{ props.item.esi_amount ? handy.formatNum(props.item.esi_amount) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #FFF9C4">{{ props.item.pf_amount ? handy.formatNum(props.item.pf_amount) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #FFF9C4">{{ props.item.pt_amount ? handy.formatNum(props.item.pt_amount) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #FFF9C4">{{ props.item.tds_amount ? handy.formatNum(props.item.tds_amount) : '-' }}</td>
                                    <td style="font-size: 13px; text-align: right; background-color: #FFF9C4"><strong>{{ props.item.tot_deduction ? handy.formatNum(props.item.tot_deduction) : '-' }}</strong></td>
                                    <td style="font-size: 13px; text-align: right; background-color: #81C784"><strong>{{ props.item.net_salary ? handy.formatNum(props.item.net_salary) : '-' }}</strong></td>
                                    <td style="font-size: 12px; text-align: center; background-color: #FFEB3B"><strong>{{ props.item.worked_days ? props.item.worked_days : '-' }}</strong></td>
                                    <td style="font-size: 12px; text-align: center; background-color: #B3E5FC">{{ props.item.billing_cycle_days ? props.item.billing_cycle_days : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B3E5FC">{{ props.item.net_takehome ? handy.formatNum(props.item.net_takehome) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B3E5FC">{{ props.item.ref_takehome ? handy.formatNum(props.item.ref_takehome) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B3E5FC">{{ props.item.ref_pt_amt ? handy.formatNum(props.item.ref_pt_amt) : '-' }}</td>
                                    <td style="font-size: 12px; text-align: right; background-color: #B3E5FC">{{ props.item.ref_net_takehome ? handy.formatNum(props.item.ref_net_takehome) : '-' }}</td>
                                  </tr>
                                </template>
                                <!-- list of menuitems -->
                                <v-list v-if="(config.IS_EDITED_BY_USER)">
                                  <v-list-item style="height: 12px;" v-if="props.item.payroll_process_det_id" :disabled="(lPayrollProcessBase.base_status !== 'Draft' && config.ROLE_NAME != 'Super Admin')" @click="prepareUpdatePayrollProcessDetail(props.item)">
                                    <v-list-item-avatar><v-icon small :disabled="(lPayrollProcessBase.base_status !== 'Draft' && config.ROLE_NAME != 'Super Admin')">mdi-pencil</v-icon></v-list-item-avatar>
                                    <v-list-item-title style="font-size: 14px;">Edit</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item style="height: 12px;" v-if="props.item.payroll_process_det_id" :disabled="(lPayrollProcessBase.base_status !== 'Draft' && config.ROLE_NAME != 'Super Admin')" @click="prepareDeletePayrollProcessDetail(props.item)">
                                    <v-list-item-avatar><v-icon small :disabled="(lPayrollProcessBase.base_status !== 'Draft' && config.ROLE_NAME != 'Super Admin')">mdi-delete</v-icon></v-list-item-avatar>
                                    <v-list-item-title style="font-size: 14px;">Delete</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item style="height: 12px;" v-if="props.item.payroll_process_det_id" @click="prepareViewPayrollProcessDetail(props.item)">
                                    <v-list-item-avatar><v-icon small>mdi-book-open-blank-variant</v-icon></v-list-item-avatar>
                                    <v-list-item-title style="font-size: 14px;">View</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item style="height: 12px;" v-if="props.item.payroll_process_det_id" :disabled="(lPayrollProcessBase.base_status !== 'Draft' && config.ROLE_NAME != 'Super Admin')" @click="prepareBulkDeletePayrollProcessDetail(props.item)">
                                    <v-list-item-avatar><v-icon small>mdi-delete-sweep</v-icon></v-list-item-avatar>
                                    <v-list-item-title style="font-size: 14px;">Bulk Delete</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item style="height: 12px;" v-if="props.item.payroll_process_det_id" :disabled="(lPayrollProcessBase.base_status !== 'Draft' && config.ROLE_NAME != 'Super Admin')" @click="processRecord(props.item)">
                                    <v-list-item-avatar><v-icon small>mdi-delete-sweep</v-icon></v-list-item-avatar>
                                    <v-list-item-title style="font-size: 14px;">Process</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-text>
                <v-card-actions class="py-2 pl-2 grey lighten-4">
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs4 class="text-left">
                        <v-btn style="font-size: 10px; width: 200px;" class="font-weight-bold accent mr-2" small :disabled="(payrollProcessDetailList.length === 0)" @click="loadCompareBillingandSalaryForBaseIdDetails(lPayrollProcessBase)">Compare Billing & Salary</v-btn>
                      </v-flex>
                      <v-flex xs8 class="text-right">
                        <v-btn style="font-size: 10px; width: 100px;" class="font-weight-bold accent mr-2" small :disabled="(payrollProcessDetailList.length === 0)" v-if="lPayrollProcessBase.base_status === 'Draft' && (config.IS_EDITED_BY_USER)" @click="preparePayrollProcessStatus(lPayrollProcessBase, 'Submitted')">Submit</v-btn>
                        <v-btn style="font-size: 10px; width: 100px;" class="font-weight-bold accent mr-2" small v-if="lPayrollProcessBase.base_status === 'Submitted' && (config.IS_EDITED_BY_USER)" @click="preparePayrollProcessStatus(lPayrollProcessBase, 'Approved')">Approve</v-btn>
                        <v-btn style="font-size: 10px; width: 100px;" class="font-weight-bold accent mr-2" small v-if="lPayrollProcessBase.base_status === 'Submitted' && (config.IS_EDITED_BY_USER)" @click="preparePayrollProcessStatus(lPayrollProcessBase, 'Rejected')">Reject</v-btn>
                        <v-btn style="font-size: 10px; width: 150px;" class="font-weight-bold accent mr-2" small v-if="config.IS_EDITED_BY_USER && (lPayrollProcessBase.base_status === 'Approved' || lPayrollProcessBase.base_status === 'Absolute Approved')" @click="prepareRevision(lPayrollProcessBase)">create revision</v-btn>
                        <v-btn style="font-size: 10px; width: 150px;" class="font-weight-bold accent mr-2" small v-if="(lPayrollProcessBase.base_status === 'Approved' || lPayrollProcessBase.base_status === 'Obsolete Approved') && config.ROLE_NAME === 'Super Admin' && (config.IS_EDITED_BY_USER)" @click="preparePayrollProcessStatus(lPayrollProcessBase, 'Draft')">convert as draft</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- 3. show remaining / imported project list and import status -->
        <v-dialog v-model="showImportedProjectListDialog" persistent scrollable max-width="550px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Payroll Process Project Import Status
              <v-spacer></v-spacer>
              <v-btn icon small @click="showImportedProjectListDialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-data-table
              :headers="importedProjectListHead"
              :items="importedProjectList"
              hide-default-footer
              dense
              disable-pagination
              :mobile-breakpoint="0"
              class="elevation-1"
              >
                <template slot="item" slot-scope="props">
                  <tr :class="props.item.is_imported === 'Yes' ? 'green--text' : 'red--text'">
                    <td style="font-size: 12px; text-align: center;">{{ props.index + 1 }}</td>
                    <td style="font-size: 12px; text-align: left;">{{ props.item.proj_name }}</td>
                    <td style="font-size: 12px; text-align: center;">{{ props.item.is_imported }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- 4. Project wise employee import -->
        <v-dialog v-model="showProjectWiseEmpImportDialog" persistent scrollable max-width="1000px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Employee Import (for the month : {{ lPayrollProcessBase.payroll_month_year }} )
              <v-spacer></v-spacer>
              <v-btn icon small @click="showProjectWiseEmpImportDialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-flex xs12 class="pa-3">
                <v-layout row wrap>
                  <v-flex xs2 class="ml-1">
                    <v-autocomplete
                    v-model="lImportPayrollProcessDetail.proj_category"
                    label="Select category"
                    :items="['Active', 'Inactive']"
                    dense
                    style="font-size: 12px"
                    hide-details
                    @input="changeProjectCategory()"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs4 class="ml-2" v-if="lImportPayrollProcessDetail.proj_category === 'Active'">
                    <v-autocomplete
                    v-model="lImportPayrollProcessDetail.comm_id"
                    :items="commList"
                    item-text="comm_name"
                    item-value="comm_id"
                    label="Project"
                    dense
                    style="font-size: 12px"
                    hide-details
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs4 class="ml-2" v-if="lImportPayrollProcessDetail.proj_category === 'Inactive'">
                    <v-autocomplete
                    v-model="lImportPayrollProcessDetail.comm_id"
                    :items="inactiveCommList"
                    item-text="comm_name"
                    item-value="comm_id"
                    label="Project"
                    dense
                    style="font-size: 12px"
                    hide-details
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2 class="ml-2">
                    <v-dialog ref="dlgimportstartDt"
                    persistent v-model="dlgimportstartDt"
                    max-width="290px"
                    class="pt-0"
                    :return-value.sync="lImportPayrollProcessDetail.month_start_dt">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                        label="Month Start Date"
                        v-model="lImportPayrollProcessDetail.month_start_dt" append-icon="mdi-calendar-today"
                        readonly
                        v-on="on"
                        dense
                        style="font-size: 12px"
                        hide-details
                        ></v-text-field>
                      </template>
                      <v-date-picker @input="loadEndDateBasedOnStartingDate(lImportPayrollProcessDetail.month_start_dt)"
                      v-model="lImportPayrollProcessDetail.month_start_dt"
                      scrollable
                      >
                        <div class="flex-grow-1"></div>
                        <v-btn text @click="dlgimportstartDt = false">Cancel</v-btn>
                        <v-btn text color="accent" @click="$refs.dlgimportstartDt.save(lImportPayrollProcessDetail.month_start_dt)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs2 class="ml-2">
                    <v-dialog ref="dlgimportendDt"
                    persistent v-model="dlgimportendDt"
                    max-width="290px"
                    class="pt-0"
                    :return-value.sync="lImportPayrollProcessDetail.month_end_dt">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                        slot="activator" label="Month End Date"
                        v-model="lImportPayrollProcessDetail.month_end_dt" append-icon="mdi-calendar-today"
                        readonly
                        hide-details
                        dense
                        style="font-size: 12px"
                        v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                      :min="lImportPayrollProcessDetail.month_start_dt"
                      v-model="lImportPayrollProcessDetail.month_end_dt"
                      scrollable
                      >
                        <div class="flex-grow-1"></div>
                        <v-btn text @click="dlgimportendDt = false">Cancel</v-btn>
                        <v-btn text color="accent" @click="$refs.dlgimportendDt.save(lImportPayrollProcessDetail.month_end_dt)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs1 class="ml-5 mt-2">
                    <v-btn small color="accent" @click="searchProjetWiseEmployeesForImport()">Go</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 class="pa-3">
                <div>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-data-table
                        v-model="selected"
                        :headers="projectWiseEmpImportHeader"
                        :items="projectWiseEmpImportList"
                        item-key="key_vendor_emp_id_with_type"
                        show-select
                        fixed-header
                        dense
                        disable-pagination
                        hide-default-footer
                        class="elevation-5 importtableth importtabletd"
                      >
                        <template #item="{ item }">
                          <tr>
                            <td><v-checkbox :disabled="item.import_status === 'Imported'"
                              class="pa-0 ma-0"
                              :ripple="false"
                              v-model="selected"
                              :value="item"
                              hide-details></v-checkbox></td>
                            <td :class="item.import_status === 'Imported' ? 'green--text' : 'red--text'">{{item.emp_name}}</td>
                            <td :class="item.import_status === 'Imported' ? 'green--text' : 'red--text'">{{item.staff_role}}</td>
                            <td :class="item.import_status === 'Imported' ? 'green--text' : 'red--text'">{{item.emp_desig}}</td>
                            <td :class="item.import_status === 'Imported' ? 'green--text' : 'red--text'">{{item.vendor_emp_id}}</td>
                            <td :class="item.import_status === 'Imported' ? 'green--text' : 'red--text'">{{item.proj_name}}</td>
                            <td :class="item.import_status === 'Imported' ? 'green--text' : 'red--text'">{{item.import_status}}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-flex xs12 class="">
                <v-layout row wrap>
                  <v-flex xs11>
                    <div class="caption text-center"><span class="font-weight-bold" style="font-size: 14px">Total Employees: {{ parseInt(this.lImportPayrollProcessDetail.importedCount ? this.lImportPayrollProcessDetail.importedCount : 0) + parseInt(this.lImportPayrollProcessDetail.notImportedCount ? this.lImportPayrollProcessDetail.notImportedCount : 0) }} </span>
                      <span class="green--text font-weight-bold" style="font-size: 14px"> | Imported: {{ this.lImportPayrollProcessDetail.importedCount ? this.lImportPayrollProcessDetail.importedCount : 0 }} </span>
                      <span class="red--text font-weight-bold" style="font-size: 14px"> | Not Imported: {{ this.lImportPayrollProcessDetail.notImportedCount ? this.lImportPayrollProcessDetail.notImportedCount : 0 }} </span></div>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn small class="accent" :disabled="beingSaved" @click="importProjWiseEmployees(selected)">Import</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 5. update payroll process det -->
        <v-dialog v-model="showPayrollProcessDetailUpdateDialog" persistent scrollable max-width="600px">
          <v-form ref="pDetForm" @submit.prevent="savePayrollProcessDetailUpdate(lPayrollProcessDetail.action)">
            <v-card>
              <v-card-title class="py-2 grey lighten-4">
                {{ handy.startWithUpper(lAction) }} Payroll Process Employee Detail
              </v-card-title>
              <v-card-text class="pt-0 pb-2">
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs3 class="pt-5">
                      <div class="text-center font-weight-bold"> Month-Year : <span class="blue--text"> {{lPayrollProcessDetail.payroll_month_year}}</span></div>
                    </v-flex>
                    <v-flex xs3 class="pt-5">
                      <div class="text-center font-weight-bold"> Days in Month : <span class="blue--text"> {{lPayrollProcessDetail.month_days}}</span></div>
                    </v-flex>
                    <v-flex xs3 class="pt-5">
                      <div class="text-center font-weight-bold"> Version : <span class="blue--text">{{lPayrollProcessDetail.base_version}}</span></div>
                    </v-flex>
                    <v-flex xs3  class="pt-5">
                      <div class="text-center font-weight-bold"> Status : <span class="blue--text">{{lPayrollProcessDetail.base_status}}</span></div>
                    </v-flex>
                    <v-flex xs6 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessDetail.proj_name"
                      label="Project Name"
                      hide-details
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessDetail.emp_desig"
                      label="Designation"
                      hide-details
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessDetail.vendor_emp_id"
                      label="Employee Id"
                      hide-details
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      :disabled="lPayrollProcessDetail.vendor_emp_id != '' || lPayrollProcessDetail.action === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs9 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessDetail.emp_name"
                      label="Employee Name"
                      hide-details
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      disabled
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessDetail.worked_days"
                      label="Worked Days"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="claculateReferenceSalary()"
                      :disabled="lPayrollProcessDetail.action === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessDetail.ref_takehome"
                      label="Ref Takehome"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      :disabled="lPayrollProcessDetail.action === 'view'"
                      @input="calculateReferenceAmountsEditByEnteringManual('ref_th')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessDetail.ref_pt_amt"
                      label="Ref PT"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      :disabled="lPayrollProcessDetail.action === 'view'"
                      @input="calculateReferenceAmountsEditByEnteringManual('pt')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessDetail.ref_net_takehome"
                      label="Ref Net Takehome"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      :disabled="lPayrollProcessDetail.action === 'view'"
                      @input="calculateReferenceAmountsEditByEnteringManual('ref_net_th')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 class="pa-1 pt-3">
                      <v-checkbox hide-details
                      label="Is Net TH fixed?"
                      v-model="lPayrollProcessDetail.is_ref_net_takehome_adjusted"
                      class="my-label-text-size"
                      :disabled="lPayrollProcessDetail.action === 'view'"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs12 class="pa-1 pt-3">
                      <v-text-field
                      v-model="lPayrollProcessDetail.remarks"
                      label="Remarks (if any)"
                      style="font-size: 14px"
                      hide-details
                      :disabled="lPayrollProcessDetail.action === 'view'"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
              <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
                <v-btn small @click="closePayrollProcessDetailDialog()">close</v-btn>
                <v-btn small class="accent" :disabled="lPayrollProcessDetail.action === 'view'" v-if="config.IS_EDITED_BY_USER" type="submit">save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <!-- 6. Bulk Delete - Payroll Process Detail -->
        <v-dialog v-model="showBulkDeletePayrollProcessDialog" persistent scrollable max-width="1000px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Bulk Delete Employee Details (for the month : {{ lPayrollProcessBase.payroll_month_year }} )
              <v-spacer></v-spacer>
              <v-btn icon small @click="showBulkDeletePayrollProcessDialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-flex xs12 class="pa-3">
                <v-layout row wrap>
                  <v-flex xs6 class="ml-2">
                    <v-autocomplete
                    v-model="lBulkDeletePayrollProcessDetail.comm_id"
                    :items="bulkDeleteCommList"
                    item-text="comm_name"
                    item-value="comm_id"
                    label="Select Project"
                    dense
                    style="font-size: 12px"
                    hide-details
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1 class="ml-5 mt-2">
                    <v-btn small color="accent" @click="searchProjetWiseEmployeesForBulkDelete()">Search</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 class="pa-3">
                <div>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-data-table
                        v-model="selected"
                        :headers="bulkDeletePayrollProcessHeader"
                        :items="bulkDeletePayrollProcessDetailList"
                        item-key="payroll_process_det_id"
                        show-select
                        fixed-header
                        dense
                        disable-pagination
                        hide-default-footer
                        class="elevation-5 importtableth importtabletd"
                      >
                        <template #item="{ item }">
                          <tr>
                            <td><v-checkbox
                              class="pa-0 ma-0"
                              :ripple="false"
                              v-model="selected"
                              :value="item"
                              hide-details></v-checkbox></td>
                            <td>{{item.vendor_emp_id}}</td>
                            <td>{{item.emp_name}}</td>
                            <td>{{item.emp_desig}}</td>
                            <td>{{item.proj_name}}</td>
                            <td>{{item.budget_takehome_salary ? handy.formatCur(item.budget_takehome_salary) : '-'}}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small class="accent" :disabled="beingSaved" @click="bulkDeletePayrollProcessDetail(selected)">Delete Selected</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 7. Create / Update/ View Add Employee Detail -->
        <v-dialog v-model="showAddEmployeeDetailDialog" persistent scrollable max-width="700px">
          <v-form ref="pEmpAddForm" @submit.prevent="saveAddEmployeeDetail(lMAction)">
            <v-card>
              <v-card-title class="py-2 grey lighten-2">
                {{ handy.startWithUpper(lMAction) }} Employee Detail
              </v-card-title>
              <v-card-text class="pt-1 pb-2">
                <v-flex xs12 class="pa-2">
                  <v-layout class="info lighten-2 pb-2" row wrap>
                    <v-flex xs3 class="pt-2">
                      <div class="text-center font-weight-bold"> Month-Year : <span class="blue--text"> {{lPayrollProcessBase.payroll_month_year}}</span></div>
                    </v-flex>
                    <v-flex xs3 class="pt-2">
                      <div class="text-center font-weight-bold"> Days in Month : <span class="blue--text"> {{lPayrollProcessBase.month_days}}</span></div>
                    </v-flex>
                    <v-flex xs3 class="pt-2">
                      <div class="text-center font-weight-bold"> Version : <span class="blue--text">{{lPayrollProcessBase.base_version}}</span></div>
                    </v-flex>
                    <v-flex xs3 class="pt-2">
                      <div class="text-center font-weight-bold"> Status : <span class="blue--text">{{lPayrollProcessBase.base_status}}</span></div>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs2 class="pa-1 pt-3">
                      <v-autocomplete
                      v-model="lAddEmployeeDetail.proj_category"
                      label="Select category"
                      :items="['Active', 'Inactive']"
                      dense
                      style="font-size: 12px"
                      hide-details
                      @input="changeAddEmployeeProjectCategory()"
                      :disabled="lMAction === 'view'"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs5 class="pa-1 pt-3" v-if="lAddEmployeeDetail.proj_category === 'Active'">
                      <v-autocomplete
                      v-model="lAddEmployeeDetail.comm_id"
                      :items="commList"
                      item-text="comm_name"
                      item-value="comm_id"
                      label="Community"
                      dense
                      style="font-size: 12px"
                      hide-details
                      @input="loadProjectForCommunity()"
                      :disabled="lMAction === 'view'"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs5 class="pa-1 pt-3" v-if="lAddEmployeeDetail.proj_category === 'Inactive'">
                      <v-autocomplete
                      v-model="lAddEmployeeDetail.comm_id"
                      :items="inactiveCommList"
                      item-text="comm_name"
                      item-value="comm_id"
                      label="Community"
                      dense
                      style="font-size: 12px"
                      hide-details
                      @input="loadProjectForCommunity()"
                      :disabled="lMAction === 'view'"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs5 class="pa-1 pt-3">
                      <v-autocomplete
                      v-model="lAddEmployeeDetail.proj_id"
                      :items="projectList"
                      item-text="proj_name"
                      item-value="proj_id"
                      label="Project"
                      dense
                      style="font-size: 12px"
                      hide-details
                      :disabled="lMAction === 'view'"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs2 class="pa-1">
                      <v-text-field
                      v-model="lAddEmployeeDetail.vendor_emp_id"
                      label="Emp Id"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5 class="pa-1">
                      <v-text-field
                      v-model="lAddEmployeeDetail.emp_name"
                      label="Employee Name"
                      hide-details
                      maxlength="50"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5 class="pa-1">
                      <v-text-field
                      v-model="lAddEmployeeDetail.emp_desig"
                      label="Employee Designation"
                      hide-details
                      maxlength="35"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1">
                      <v-checkbox hide-details
                      label="Is ESI Opted?"
                      v-model="lAddEmployeeDetail.is_esi_opted"
                      class="my-label-text-size"
                      :disabled="lMAction === 'view'"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs2 class="pa-1">
                      <v-checkbox hide-details
                      label="Is PF Opted?"
                      v-model="lAddEmployeeDetail.is_pf_opted"
                      class="my-label-text-size"
                      :disabled="lMAction === 'view'"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-5">
                      <v-autocomplete
                      v-model="lAddEmployeeDetail.payroll_cat"
                      label="Select category"
                      :items="['PF', 'TDS']"
                      dense
                      style="font-size: 12px"
                      hide-details
                      :rules="[rules.required]"
                      :disabled="lMAction === 'view'"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.cust_budget_salary"
                      label="Budget Salary"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.cust_billing_salary"
                      label="Billing Salary"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.budget_takehome_salary"
                      label="Budget Takehome"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateReferenceAmounts()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.worked_days"
                      label="Worked Days"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateReferenceAmounts()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.billing_cycle_days"
                      label="Billing Cyl Days"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateReferenceAmounts()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.fixedwages_basic"
                      label="Fixed Basic"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateFixedGrossAmount()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.fixedwages_da"
                      label="Fixed DA"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateFixedGrossAmount()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.fixedwages_hra"
                      label="Fixed HRA"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateFixedGrossAmount()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.fixedwages_conveyance"
                      label="Fixed Conveyance"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateFixedGrossAmount()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.fixedwages_washing"
                      label="Washing Allowance"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateFixedGrossAmount()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.fixedwages_other_allowance"
                      label="Other Allowance"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateFixedGrossAmount()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.fixedwages_leave_wages"
                      label="Leave Wages"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateFixedGrossAmount()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.fixedwages_performincentive"
                      label="Incentive"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateFixedGrossAmount()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.fixedwages_bonus"
                      label="Bonus"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateFixedGrossAmount()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.fixedwages_child_edu"
                      label="Child Education"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateFixedGrossAmount()"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.fixedwages_gross_salary"
                      label="Fixed Gross"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      disabled
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.ref_takehome"
                      label="Ref Takehome"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateReferenceAmountsAddEmpByEnteringManual('ref_th')"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.ref_pt_amt"
                      label="Ref PT"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateReferenceAmountsAddEmpByEnteringManual('pt')"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lAddEmployeeDetail.ref_net_takehome"
                      label="Ref Net Takehome"
                      hide-details
                      type="number"
                      style="font-size: 14px"
                      :rules="[rules.required]"
                      @input="calculateReferenceAmountsAddEmpByEnteringManual('ref_net_th')"
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs10 class="pa-1 pt-2">
                      <v-text-field
                      v-model="lPayrollProcessBase.base_remarks"
                      label="Remarks (if any)"
                      style="font-size: 14px"
                      hide-details
                      :disabled="lMAction === 'view'"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
              <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
                <v-btn small @click="closeAddEmployeeDialog()">close</v-btn>
                <v-btn small :disabled="lMAction === 'view'" class="accent" v-if="config.IS_EDITED_BY_USER" type="submit">save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <!-- 8. Add Comments -->
        <v-dialog v-model="showCommentDlg" scrollable persistent max-width="500px">
          <v-card>
            <v-card-title class="px-3 py-2 title grey lighten-4">
              {{lPayrollProcessStatus.status}} Remarks
              <v-spacer></v-spacer>
              <v-btn icon @click="showCommentDlg = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-flex xs12 v-if="lPayrollProcessStatus.status === 'Submitted'">
                <v-textarea hide-details outlined
                placeholder="Please Enter the Submit Remarks"
                maxlength="250"
                v-model="lPayrollProcessStatus.submit_remarks"></v-textarea>
              </v-flex>
              <v-flex xs12 v-if="lPayrollProcessStatus.status === 'Approved'">
                <v-textarea hide-details outlined
                placeholder="Please Enter the Approve Remarks"
                maxlength="250"
                v-model="lPayrollProcessStatus.approve_remarks"></v-textarea>
              </v-flex>
              <v-flex xs12 v-if="lPayrollProcessStatus.status === 'Draft'">
                <v-textarea hide-details outlined
                placeholder="Please Enter the Draft Remarks"
                maxlength="250"
                v-model="lPayrollProcessStatus.drafted_remarks"></v-textarea>
              </v-flex>
              <v-flex xs12 v-if="lPayrollProcessStatus.status === 'Rejected'">
                <v-textarea hide-details outlined
                placeholder="Please Enter the Rejected Remarks"
                maxlength="250"
                v-model="lPayrollProcessStatus.rejected_remarks"></v-textarea>
              </v-flex>
            </v-card-text>
            <v-card-actions class="px-3 pt-0">
              <v-spacer></v-spacer>
              <v-btn class="accent" @click="statusChangeTheProjectContract(lPayrollProcessStatus, lPayrollProcessStatus.status)">save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 9. Compare Billing and Salary processed -->
        <v-dialog v-model="showCompareDlg" persistent scrollable max-width="1000px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-2">
              Billing and Salary Comparison (for the Month-Year : {{ lPayrollProcessBase.payrollMonth }}-{{ lPayrollProcessBase.payrollYear }} )
              <v-spacer></v-spacer>
              <v-btn icon small @click="showCompareDlg = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-flex xs12 class="pa-3">
                <div>
                  <v-layout row wrap>
                    <v-flex xs12 class="pt-0">
                      <v-download-as
                      :headers="compareBillingSalaryHeader"
                      :items="compareBillingSalaryDet"
                      title="Bill and Salary Compare Report"
                      :landscape="true"
                      :fontsize="8"
                      ></v-download-as>
                    </v-flex>
                    <v-flex xs12>
                      <v-data-table
                      :headers="compareBillingSalaryHeader"
                      :items="compareBillingSalaryDet"
                      hide-default-footer
                      dense
                      disable-pagination
                      :mobile-breakpoint="0"
                      loading
                      loading-text="Loading... Please wait"
                      class="elevation-1 pt-2"
                      >
                        <template slot="item" slot-scope="props">
                          <tr>
                            <td style="font-size: 12px; text-align: center; background-color: #F1F8E9">{{ props.index + 1 }}</td>
                            <td style="font-size: 12px; text-align: left; background-color: #F1F8E9">{{ props.item.proj_name }}</td>
                            <td style="font-size: 12px; text-align: left; background-color: #F1F8E9">{{ props.item.staff_role }}</td>
                            <td style="font-size: 12px; text-align: center; background-color: #DCEDC8">{{ props.item.tot_days_worked ? props.item.tot_days_worked : '-' }}</td>
                            <td style="font-size: 12px; text-align: right; background-color: #DCEDC8">{{ props.item.billed_amt ? handy.formatCur(props.item.billed_amt) : '-' }}</td>
                            <td style="font-size: 12px; text-align: center; background-color: #B3E5FC">{{ props.item.worked_days ? props.item.worked_days : '-' }}</td>
                            <td style="font-size: 12px; text-align: right; background-color: #B3E5FC">{{ props.item.net_salary ? handy.formatCur(props.item.net_salary) : '-' }}</td>
                            <td style="font-size: 12px; text-align: right; background-color: #81C784">{{ props.item.diff_amt ? handy.formatCur(props.item.diff_amt) : '-' }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-btn :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
        dark fab fixed color="accent" v-if="lAction === 'view' && config.IS_EDITED_BY_USER"
        @click.native="prepareCreate()"><v-icon>mdi-plus</v-icon></v-btn>

        <!-- snack bar for reporting -->
        <v-snackbar :color="sbarCol" v-model="sbar"
        :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      search: '',
      lAction: 'view',
      lMAction: '',
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      // Frontend
      selTab: 0,
      payrollProcessSummaryHead: [
        { text: 'S.No', value: '', width: '50px', align: 'center', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Month & Year', value: 'payroll_month_year', width: '120px', align: 'center', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Version', value: 'base_version_text', width: '200px', align: 'center', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Status', value: 'base_status', width: '200px', align: 'center', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Month Days', value: 'month_days', width: '100px', align: 'center', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Remarks', value: 'remarks', class: 'uniformchipinfo white--text' }
      ],
      lPayrollProcessSummaryList: [],
      yearList: [],
      lPayrollProcessBase: [],
      showCreatePayrollProcessBase: false,
      dlgPayrollProcessMon: false,
      payrollBaseAlreadyExists: false,
      payrollProcessVersionList: [],
      payrollProcessDetailList: [],
      isProcessingPayroll: false,
      searchPayrollProcessDetail: '',
      payrollProcessDetailHeaders: [
        { text: 'SNo', value: 'Sno', width: '50px', align: 'center', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Emp ID', value: 'vendor_emp_id', width: '100px', align: 'center', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Emp Name', value: 'emp_name', width: '170px', align: 'left', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Staff Role', value: 'site_staff_role', width: '170px', align: 'left', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Designation', value: 'emp_desig', width: '170px', align: 'left', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Project Name', value: 'proj_name', width: '250px', align: 'left', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Payroll Cat', value: 'payroll_cat', width: '100px', align: 'center', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Budget Sal', value: 'cust_budget_salary', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Billing Sal', value: 'cust_billing_salary', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Budget TH', value: 'budget_takehome_salary', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Fix Basic', value: 'fixedwages_basic', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Fix DA', value: 'fixedwages_da', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Fix HRA', value: 'fixedwages_hra', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Fix Conv', value: 'fixedwages_conveyance', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Fix Wash', value: 'fixedwages_washing', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Fix Oth Allow', value: 'fixedwages_other_allowance', width: '110px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Fix Leave', value: 'fixedwages_leave_wages', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Fix Per Incent', value: 'fixedwages_performincentive', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Fixed Bonus', value: 'fixedwages_bonus', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Fix Child Edu', value: 'fixedwages_child_edu', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Fix Gross Sal', value: 'fixedwages_gross_salary', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear Pay Attnd', value: 'earnedwages_payroll_attendance', width: '120px', align: 'center', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear Basic', value: 'earnedwages_basic', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Earned DA', value: 'earnedwages_da', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Earned HRA', value: 'earnedwages_hra', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear Conv', value: 'earnedwages_conveyance', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear Wash', value: 'earnedwages_washing', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear Oth Allow', value: 'earnedwages_other_allowance', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear Leave', value: 'earnedwages_leave_wages', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear Per Incentive', value: 'earnedwages_performincentive', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear Bonus', value: 'earnedwages_bonus', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear Child Edu', value: 'earnedwages_child_edu', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear Adj.Amt', value: 'earnedwages_adjust_amt', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear NFH.Amt', value: 'earnedwages_nfh', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear OT.Amt', value: 'earnedwages_ot', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ear Gross Sal', value: 'earnedwages_gross_salary', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'ESI Amt', value: 'esi_amount', width: '80px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'PF Amt', value: 'pf_amount', width: '80px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'PT Amt', value: 'pt_amount', width: '80px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'TDS Amt', value: 'tds_amount', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Tot.Deduction', value: 'tot_deduction', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Net Salary', value: 'net_salary', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Worked Days', value: 'worked_days', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Bill Cyc.Days', value: 'billing_cycle_days', width: '120px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Net TH', value: 'net_takehome', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ref.TH', value: 'ref_takehome', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ref.PT.Amt', value: 'ref_pt_amt', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false },
        { text: 'Ref.Net.TH', value: 'ref_net_takehome', width: '100px', align: 'right', class: 'uniformchipinfo white--text', sortable: false }
      ],
      lPayrollProcessDetail: [],
      importedProjectList: [],
      showImportedProjectListDialog: false,
      importedProjectListHead: [
        { text: 'S.No', value: '', class: 'uniformchipinfo white--text', align: 'center' },
        { text: 'Project Name', value: 'proj_name', class: 'uniformchipinfo white--text', align: 'left' },
        { text: 'Is Imported', value: 'is_imported', class: 'uniformchipinfo white--text', align: 'center' }
      ],
      payollProcessBaseIdDetails: [],
      showProjectWiseEmpImportDialog: false,
      selected: [],
      projectWiseEmpImportHeader: [
        { text: 'Employee Name', value: 'emp_name', class: 'uniformchipinfo white--text', width: '170px', align: 'left', sortable: false },
        { text: 'Staff Role', value: 'site_staff_role', class: 'uniformchipinfo white--text', width: '170px', align: 'left', sortable: false },
        { text: 'Designation', value: 'emp_desig', class: 'uniformchipinfo white--text', width: '170px', align: 'left', sortable: false },
        { text: 'Emp ID', value: 'vendor_emp_id', class: 'uniformchipinfo white--text', width: '100px', align: 'center', sortable: false },
        { text: 'Project Name', value: 'proj_name', class: 'uniformchipinfo white--text', width: '200px', align: 'left', sortable: false },
        { text: 'Status', value: 'import_status', class: 'uniformchipinfo white--text', width: '120px', align: 'center', sortable: false }
      ],
      projectWiseEmpImportList: [],
      commList: [],
      inactiveCommList: [],
      lImportPayrollProcessDetail: [],
      dlgimportstartDt: false,
      dlgimportendDt: false,
      showPayrollProcessDetailUpdateDialog: false,
      showBulkDeletePayrollProcessDialog: false,
      bulkDeletePayrollProcessHeader: [
        { text: 'Emp ID', value: 'vendor_emp_id', class: 'uniformchipinfo white--text', width: '100px', align: 'center', sortable: false },
        { text: 'Employee Name', value: 'emp_name', class: 'uniformchipinfo white--text', width: '200px', align: 'left', sortable: false },
        { text: 'Designation', value: 'emp_desig', class: 'uniformchipinfo white--text', width: '200px', align: 'left', sortable: false },
        { text: 'Project Name', value: 'proj_name', class: 'uniformchipinfo white--text', width: '200px', align: 'left', sortable: false },
        { text: 'Budget TH', value: 'budget_takehome_salary', class: 'uniformchipinfo white--text', width: '120px', align: 'keyboard_arrow_right', sortable: false }
      ],
      bulkDeleteCommList: [],
      bulkDeletePayrollProcessDetailList: [],
      lBulkDeletePayrollProcessDetail: [],
      showAddEmployeeDetailDialog: false,
      lAddEmployeeDetail: [],
      projectList: [],
      lPayrollProcessStatus: [],
      showCommentDlg: false,
      showCompareDlg: false,
      compareBillingSalaryDet: [],
      compareBillingSalaryHeader: [
        { text: 'Sno', value: 'sno', class: 'uniformchipinfo white--text', width: '55px', align: 'center', sortable: false },
        { text: 'Project Name', value: 'proj_name', class: 'uniformchipinfo white--text', width: '200px', align: 'left', sortable: false },
        { text: 'Staff Role', value: 'staff_role', class: 'uniformchipinfo white--text', width: '170px', align: 'left', sortable: false },
        { text: 'Bill Days', value: 'tot_days_worked', class: 'uniformchipinfo white--text', width: '80px', align: 'center', sortable: false },
        { text: 'Bill Amount', value: 'billed_amt', class: 'uniformchipinfo white--text', width: '120px', align: 'right', sortable: false },
        { text: 'Salary Days', value: 'worked_days', class: 'uniformchipinfo white--text', width: '100px', align: 'center', sortable: false },
        { text: 'Salary Amount', value: 'net_salary', class: 'uniformchipinfo white--text', width: '120px', align: 'right', sortable: false },
        { text: 'Difference', value: 'diff_amt', class: 'uniformchipinfo white--text', width: '120px', align: 'right', sortable: false }
      ],
    }
  },
  created () {
    this.lPayrollProcessBase = []
    this.loadPayrollProcessSummaryList()
  },
  mounted () {
    // this.filterList = this.getEmptyFilter()
    this.loadPayrollProcessSummaryList()
  },
  methods: {
    searchMonthYearTitle (curRec) {
      if (curRec && curRec.length > 1) {
        var tmpVar = this.yearList.filter(rec => rec.toLowerCase().includes(curRec.toLowerCase()))
        if (tmpVar.length > 0) {
          this.yearList = []
          this.yearList = tmpVar
        } else {
          this.yearList = []
        }
      } else {
        this.loadPayrollProcessSummaryList()
      }
    },
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadPayrollProcessSummaryList () {
      // console.log('load')
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.lPayrollProcessSummaryList = []
      this.axios.get(config.API_URL + '/getPayrollProcessSummaryList/', qry)
      .then(response => {
        this.lPayrollProcessSummaryList = response.data
        this.yearList = handy.unique(this.lPayrollProcessSummaryList.map(rec => rec.payrollYear))
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreate () {
      this.lPayrollProcessBase = {
        payroll_process_base_id: null,
        payroll_month_year: '',
        base_version: '1.0',
        base_status: 'Draft',
        ESI_percent_employee: '0.75',
        ESI_percent_employer: '3.25',
        PF_percent_employee: '12',
        PF_percent_employer: '13.61',
        PF_restrict_limit_employee: '1800',
        PF_restrict_limit_employer: '1950',
        professional_tax_amt: '200',
        prof_ser_tds_percent: '10',
        pt_eligible_ref_amt: '25000',
        pt_limit_amt: '25000',
        month_days: '0',
        remarks: '',
        created_by: config.EMP_ID,
        updated_by: config.EMP_ID,
        vendor_id: config.VENDOR_ID
      }
      this.lPayrollProcessDetList = []
      this.showCreatePayrollProcessBase = true
      this.payrollBaseAlreadyExists = false
      this.lAction = 'create'
    },
    loadExistingPayrollProcessifAnyforSelectedMonthYear (curMonthYear) {
      var qry = {
        params: {
          payroll_month_year: this.lPayrollProcessBase.payroll_month_year,
          vendor_id: config.VENDOR_ID
        }
      }
      this.payrollBaseAlreadyExists = false
      this.axios.get(config.API_URL + '/getPayrollProcessForGivenMonthYear/', qry)
      .then(response => {
        if (response.data.length > 0 ) {
          this.payrollBaseAlreadyExists = true
        }
        else {
          this.payrollBaseAlreadyExists = false
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
      this.loadMonthdaysforSelectedMonthYear (curMonthYear)
    },
    loadMonthdaysforSelectedMonthYear (curMonthYear) {
      this.lPayrollProcessBase.month_days = new Date(curMonthYear.substring(0, 4), curMonthYear.substring(5).replace('-',''), 0).getDate();
    },
    savePayrollProcessBase (action) {
      var qry = {
        params: {
          payroll_month_year: this.lPayrollProcessBase.payroll_month_year,
          vendor_id: config.VENDOR_ID
        }
      }
      this.loadMonthdaysforSelectedMonthYear (this.lPayrollProcessBase.payroll_month_year)
      setTimeout(() => {
        if (action === 'update' && !confirm('Sure, want to update base details? Need to process all the records once again due to base detail change.')) {
          return
        }
        if (this.$refs.pForm.validate()) {
          if (!this.lPayrollProcessBase.payroll_month_year || !this.lPayrollProcessBase.ESI_percent_employee || !this.lPayrollProcessBase.ESI_percent_employer || !this.lPayrollProcessBase.PF_percent_employee || !this.lPayrollProcessBase.PF_percent_employer || !this.lPayrollProcessBase.PF_restrict_limit_employee || !this.lPayrollProcessBase.PF_restrict_limit_employer || !this.lPayrollProcessBase.professional_tax_amt || !this.lPayrollProcessBase.prof_ser_tds_percent || !this.lPayrollProcessBase.pt_limit_amt || !this.lPayrollProcessBase.pt_eligible_ref_amt) {
            this.msg('Please select all mandatory fields', 0)
          } else {
            this.axios.get(config.API_URL + '/getPayrollProcessForGivenMonthYear/', qry)
            .then(response => {
              // show already created text for only create. if it is update just update the fields.
              if (response.data.length > 0 && action === 'create') {
                this.msg('Payroll Process already created for selected Month and Year : ' + this.lPayrollProcessBase.payroll_month_year, 0)
              } else {
                this.axios.post(config.API_URL + '/payrollProcessBase/' + action, this.lPayrollProcessBase)
                .then(response => {
                  this.lPayrollProcessBase.payroll_process_base_id = response.data
                  this.loadPayrollProcessSummaryList()
                  // if the action is create then it is launched from summary page and show the summary page after save.
                  if (action === 'create') {
                    this.lAction = 'view'
                  }
                  this.msg('Saved Successfully', 1)
                  this.showCreatePayrollProcessBase = false
                })
                .catch(err => {
                  this.msg(err, 0)
                })
              }
            })
          }
        }
      }, 500)
    },
    prepareUpdate (curRec) {
      console.log(curRec)
      this.lPayrollProcessBase = Object.assign({}, curRec)
      this.lPayrollProcessBase.updated_by = config.EMP_ID
      this.loadPayrollProcessVersionsList()
      this.loadPayrollProcessDetailList()
      this.lAction = 'update'
    },
    loadPayrollProcessVersionsList () {
      var qry = {
        params: {
          payroll_month_year: this.lPayrollProcessBase.payroll_month_year,
          vendor_id: config.VENDOR_ID
        }
      }
      this.payrollProcessVersionList = []
      this.axios.get(config.API_URL + '/getPayrollProcessVersions/', qry)
      .then(response => {
        this.payrollProcessVersionList = response.data
        // if(this.payrollProcessVersionList.length > 0) {
        //   this.lPayrollProcessBase.version = this.payrollProcessVersionList[0].base_version
        // }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadPayrollProcessDetailList () {
      var qry = {
        params: {
          payroll_month_year: this.lPayrollProcessBase.payroll_month_year,
          base_version: this.lPayrollProcessBase.base_version,
          vendor_id: config.VENDOR_ID
        }
      }
      this.payrollProcessDetailList = []
      this.axios.get(config.API_URL + '/getPayrollProcessDetailList/', qry)
      .then(response => {
        this.payrollProcessDetailList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    deletePayrollProcessBase (curRec) {
      if (!confirm('Sure, you want to delete current Payroll Process - "' + curRec.payroll_month_year + ' ?')) {
        return
      }
      // up in db
      curRec.vendor_id = config.VENDOR_ID
      this.axios.post(config.API_URL + '/payrollProcessBase/delete', curRec)
      .then(response => {
        // refresh stats
        this.loadPayrollProcessSummaryList()
        this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    closePayrollProcessDialog () {
      this.showCreatePayrollProcessBase = false
      if (this.lAction === 'create') {
        this.lAction = 'view'
      }
    },
    showPayrollProcessBaseInfo (curRec) {
      this.showCreatePayrollProcessBase = true
    },
    changePayrollProcessVersionList () {
      this.loadParticularPayrollProcessBaseIdDetails (this.lPayrollProcessBase)
      setTimeout(() => {
        this.lPayrollProcessBase.ESI_percent_employee = this.payollProcessBaseIdDetails[0].ESI_percent_employee
        this.lPayrollProcessBase.ESI_percent_employer = this.payollProcessBaseIdDetails[0].ESI_percent_employer
        this.lPayrollProcessBase.PF_percent_employee = this.payollProcessBaseIdDetails[0].PF_percent_employee
        this.lPayrollProcessBase.PF_percent_employer = this.payollProcessBaseIdDetails[0].PF_percent_employer
        this.lPayrollProcessBase.PF_restrict_limit_employee = this.payollProcessBaseIdDetails[0].PF_restrict_limit_employee
        this.lPayrollProcessBase.PF_restrict_limit_employer = this.payollProcessBaseIdDetails[0].PF_restrict_limit_employer
        this.lPayrollProcessBase.base_status = this.payollProcessBaseIdDetails[0].base_status
        this.lPayrollProcessBase.base_version = this.payollProcessBaseIdDetails[0].base_version
        this.lPayrollProcessBase.month_days = this.payollProcessBaseIdDetails[0].month_days
        this.lPayrollProcessBase.payroll_month_year = this.payollProcessBaseIdDetails[0].payroll_month_year
        this.lPayrollProcessBase.payroll_process_base_id = this.payollProcessBaseIdDetails[0].payroll_process_base_id
        this.lPayrollProcessBase.prof_ser_tds_percent = this.payollProcessBaseIdDetails[0].prof_ser_tds_percent
        this.lPayrollProcessBase.professional_tax_amt = this.payollProcessBaseIdDetails[0].professional_tax_amt
        this.lPayrollProcessBase.remarks = this.payollProcessBaseIdDetails[0].remarks
        this.lPayrollProcessBase.vendor_id = this.payollProcessBaseIdDetails[0].vendor_id
        this.loadPayrollProcessDetailList()
      }, 500)
    },
    loadParticularPayrollProcessBaseIdDetails (curRec) {
      var qry = {
        params: {
          payroll_month_year: curRec.payroll_month_year,
          base_version: curRec.base_version,
          vendor_id: config.VENDOR_ID
        }
      }
      this.payollProcessBaseIdDetails = []
      this.axios.get(config.API_URL + '/getPayrollProcesBaseIdDetails/', qry)
      .then(response => {
        this.payollProcessBaseIdDetails = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showImportedProjectList (curRec) {
      var qry = {
        params: {
          payroll_process_base_id: curRec.payroll_process_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.importedProjectList = []
      this.axios.get(config.API_URL + '/getPayrollProcessImportedProjectList/', qry)
      .then(response => {
        this.importedProjectList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
      this.showImportedProjectListDialog = true
    },
    prepareImportPayrollDetail () {
      this.lImportPayrollProcessDetail = {
        proj_category: 'Active',
        comm_id: null,
        month_start_dt: null,
        month_end_dt: null,
        vendor_id: config.VENDOR_ID
      }
      this.projectWiseEmpImportList = []
      this.selected = []
      this.commList = []
      this.inactiveCommList = []
      this.showProjectWiseEmpImportDialog = true
      this.loadCommunity()
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.commList = []
      this.axios.get(config.API_URL + '/getProjectCommList/', qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
      this.inactiveCommList = []
      this.axios.get(config.API_URL + '/getProjectInactiveCommList/', qry)
      .then(response => {
        this.inactiveCommList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    changeProjectCategory () {
      this.lImportPayrollProcessDetail.comm_id = null
    },
    loadEndDateBasedOnStartingDate (curDate) {
      var curDt = new Date(curDate)
      var date = curDt.getDate()
      if (date === 1) {
        this.lImportPayrollProcessDetail.month_end_dt = handy.formatDBDate(new Date(curDt.getFullYear(), curDt.getMonth() + 1, 0))
      } else {
        curDt.setDate(date - 1)
        curDt.setMonth(curDt.getMonth() + 1)
        this.lImportPayrollProcessDetail.month_end_dt = handy.formatDBDate(curDt)
      }
    },
    searchProjetWiseEmployeesForImport () {
      if (!this.lImportPayrollProcessDetail.comm_id || !this.lImportPayrollProcessDetail.month_start_dt || !this.lImportPayrollProcessDetail.month_end_dt) {
        this.msg('Please select Project, Start date and End date', 0)
        return
      }
      this.employeePayrollList = []
      this.loadEmployeeDetailsForSelectedCommunityForImport ()
    },
    loadEmployeeDetailsForSelectedCommunityForImport () {
      var qry = {
        params: {
          comm_id: this.lImportPayrollProcessDetail.comm_id,
          from_dt: this.lImportPayrollProcessDetail.month_start_dt,
          to_dt: this.lImportPayrollProcessDetail.month_end_dt,
          proj_status: this.lImportPayrollProcessDetail.proj_category === 'Active' ? 'Active' : 'Closed'
        }
      }
      this.projectWiseEmpImportList = []
      this.selected = []
      this.lImportPayrollProcessDetail.importedCount = 0
      this.lImportPayrollProcessDetail.notImportedCount = 0
      // Verify that is selected employee details are already imported
      var isImportedList = []
      this.axios.get(config.API_URL + '/getPayrollProcessListOfEmployeeDetailsForGivenDatesAndComm/', qry)
      .then(response => {
        if (response.data.length === 0) {
          this.msg('No records found', 0)
        } else {
          this.projectWiseEmpImportList = response.data
          this.projectWiseEmpImportList.forEach(rec => {
            if (rec.tot_hd > 0) {
              rec.tot_present = parseInt(rec.tot_present) + (rec.tot_hd / 2)
              rec.billable = parseInt(rec.billable) + (rec.tot_hd / 2)
            }
            // Reference amount calculation
            rec.ref_takehome = 0
            rec.ref_pt_amt = 0
            rec.ref_net_takehome = 0
            rec.ref_takehome = ((rec.takehome_salary / rec.agreement) * rec.billable).toFixed()
            console.log(rec)
            if (rec.payroll_cat === 'PF' && rec.ref_takehome >= this.lPayrollProcessBase.pt_eligible_ref_amt) {
              rec.ref_pt_amt = this.lPayrollProcessBase.professional_tax_amt.toFixed()
            }
            rec.ref_net_takehome = (rec.ref_takehome - rec.ref_pt_amt).toFixed()

            // Verify imported list
            isImportedList = this.payrollProcessDetailList.filter(record => (parseInt(record.vendor_emp_id) === parseInt(rec.vendor_emp_id) && record.emp_name === rec.emp_name && record.comm_id === rec.comm_id && record.proj_id === rec.proj_id && record.emp_desig === rec.emp_desig))
            if (isImportedList.length > 0) {
              rec.import_status = 'Imported'
              rec.isSelectable = false
              this.lImportPayrollProcessDetail.importedCount = parseInt(this.lImportPayrollProcessDetail.importedCount) + 1
            } else {
              rec.import_status = 'Not Imported'
              rec.isSelectable = true
              this.lImportPayrollProcessDetail.notImportedCount = parseInt(this.lImportPayrollProcessDetail.notImportedCount) + 1
            }
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    importProjWiseEmployees (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        curSelectedArray.push({
          payroll_process_base_id: this.lPayrollProcessBase.payroll_process_base_id,
          created_by: config.EMP_ID,
          vendor_id: config.VENDOR_ID
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/payrollProcessImportProjWiseEmployees/', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showProjectWiseEmpImportDialog = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadPayrollProcessDetailList()
          }, 1000)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select employee from the list to import.', 0)
      }
    },
    prepareUpdatePayrollProcessDetail (curDetRec) {
      if (curDetRec.sort_order <= 3) {
        console.log(curDetRec)
        this.lPayrollProcessDetail = Object.assign({}, curDetRec)
        this.lPayrollProcessDetail.updated_by = config.EMP_ID
        this.lPayrollProcessDetail.action = 'update'
        this.showPayrollProcessDetailUpdateDialog = true
      } else {
        this.loadCommunity()
        setTimeout(() => {
          this.lAddEmployeeDetail = Object.assign({}, curDetRec)
          this.lAddEmployeeDetail.comm_id = curDetRec.comm_id
          var tempComm = this.commList.filter(rec => rec.comm_id === curDetRec.comm_id)
          if (tempComm.length > 0 ) {
            this.lAddEmployeeDetail.proj_category = 'Active'
          }
          var tempInActiveComm = this.inactiveCommList.filter(rec => rec.comm_id === curDetRec.comm_id)
          if (tempInActiveComm.length > 0 ) {
            this.lAddEmployeeDetail.proj_category = 'Inactive'
          }
          this.loadProjectForCommunity()
          this.lAddEmployeeDetail.updated_by = config.EMP_ID
          this.lMAction = 'update'
          this.showAddEmployeeDetailDialog = true
        }, 500)
      }
    },
    prepareViewPayrollProcessDetail (curDetRec) {
      if (curDetRec.sort_order <= 3) {
        this.lPayrollProcessDetail = Object.assign({}, curDetRec)
        this.lPayrollProcessDetail.updated_by = config.EMP_ID
        this.lPayrollProcessDetail.action = 'view'
        this.showPayrollProcessDetailUpdateDialog = true
      } else {
        this.loadCommunity()
        setTimeout(() => {
          this.lAddEmployeeDetail = Object.assign({}, curDetRec)
          this.lAddEmployeeDetail.comm_id = curDetRec.comm_id
          var tempComm = this.commList.filter(rec => rec.comm_id === curDetRec.comm_id)
          if (tempComm.length > 0 ) {
            this.lAddEmployeeDetail.proj_category = 'Active'
          }
          var tempInActiveComm = this.inactiveCommList.filter(rec => rec.comm_id === curDetRec.comm_id)
          if (tempInActiveComm.length > 0 ) {
            this.lAddEmployeeDetail.proj_category = 'Inactive'
          }
          this.loadProjectForCommunity()
          this.lAddEmployeeDetail.updated_by = config.EMP_ID
          this.lMAction = 'view'
          this.showAddEmployeeDetailDialog = true
        }, 500)
      }
    },
    closePayrollProcessDetailDialog () {
      this.showPayrollProcessDetailUpdateDialog = false
    },
    prepareDeletePayrollProcessDetail (curDetRec) {
      if (!confirm('Sure, you want to delete payroll process detail for Emp: "' + curDetRec.vendor_emp_id + ' - ' + curDetRec.emp_name + '"?')) {
        return
      }
      // up in db
      this.axios.post(config.API_URL + '/payrollProcessDetail/delete', curDetRec)
      .then(response => {
        // refresh stats
        this.loadPayrollProcessDetailList()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    claculateReferenceSalary () {
      // Reference amount calculation
      this.lPayrollProcessDetail.ref_takehome = 0
      this.lPayrollProcessDetail.ref_pt_amt = 0
      this.lPayrollProcessDetail.ref_net_takehome = 0
      this.lPayrollProcessDetail.ref_takehome = ((this.lPayrollProcessDetail.budget_takehome_salary / this.lPayrollProcessDetail.billing_cycle_days) * this.lPayrollProcessDetail.worked_days).toFixed()
      if (this.lPayrollProcessDetail.ref_takehome >= this.lPayrollProcessDetail.pt_eligible_ref_amt) {
        this.lPayrollProcessDetail.ref_pt_amt = this.lPayrollProcessDetail.professional_tax_amt.toFixed()
      }
      this.lPayrollProcessDetail.ref_net_takehome = (this.lPayrollProcessDetail.ref_takehome - this.lPayrollProcessDetail.ref_pt_amt).toFixed()
    },
    savePayrollProcessDetailUpdate (action) {
      if (this.$refs.pDetForm.validate()) {
        if (!confirm('Sure, want to update employee details?')) {
          return
        }
        if (this.lPayrollProcessDetail.worked_days < 0 || this.lPayrollProcessDetail.ref_takehome < 0 || this.lPayrollProcessDetail.ref_pt_amt < 0 || this.lPayrollProcessDetail.ref_net_takehome < 0) {
          this.msg('Please enter mandatory fields', 0)
        } else {
          this.axios.post(config.API_URL + '/payrollProcessDetail/' + action, this.lPayrollProcessDetail)
          .then(response => {
            this.msg('Saved Successfully', 1)
            this.processRecord(response.data[0])
            setTimeout(() => {
              this.loadPayrollProcessDetailList()
              this.showPayrollProcessDetailUpdateDialog = false
            }, 500)
          })
          .catch(err => {
            this.msg(err, 0)
          })
        }
      }
    },
    prepareBulkDeletePayrollProcessDetail () {
      this.lBulkDeletePayrollProcessDetail = {
        comm_id: null
      }
      this.selected = []
      this.bulkDeletePayrollProcessDetailList = []
      this.loadCommunityListInPayrollProcessDetails()
      this.showBulkDeletePayrollProcessDialog = true
    },
    loadCommunityListInPayrollProcessDetails () {
      var qry = {
        params: {
          payroll_process_base_id: this.lPayrollProcessBase.payroll_process_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.bulkDeleteCommList = []
      this.axios.get(config.API_URL + '/getCommunityListInPayrollProcessDetails/', qry)
      .then(response => {
        this.bulkDeleteCommList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    searchProjetWiseEmployeesForBulkDelete () {
      var qry = {
        params: {
          payroll_process_base_id: this.lPayrollProcessBase.payroll_process_base_id,
          comm_id: this.lBulkDeletePayrollProcessDetail.comm_id,
          vendor_id: config.VENDOR_ID
        }
      }
      if (!this.lBulkDeletePayrollProcessDetail.comm_id) {
        this.msg('Please select Project', 0)
        return
      }
      this.bulkDeletePayrollProcessDetailList = []
      this.axios.get(config.API_URL + '/getPayrollProcessDetailforSelectedCommunity/', qry)
      .then(response => {
        this.bulkDeletePayrollProcessDetailList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    bulkDeletePayrollProcessDetail (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        curSelectedArray.push({
          payroll_process_base_id: this.lPayrollProcessBase.payroll_process_base_id,
          vendor_id: config.VENDOR_ID
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/payrollProcessDetail/bulk-delete', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Deleted Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showBulkDeletePayrollProcessDialog = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadPayrollProcessDetailList()
          }, 1000)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select employee from the list to delete.', 0)
      }
    },
    prepareAddEmployeeDetail () {
      this.lAddEmployeeDetail = {
        proj_category: 'Active',
        payroll_process_base_id: this.lPayrollProcessBase.payroll_process_base_id,
        vendor_emp_id: null,
        emp_name: '',
        emp_desig: '',
        comm_id: null,
        proj_id: null,
        is_esi_opted: null,
        is_pf_opted: null,
        payroll_cat: 'PF',
        cust_budget_salary: '0',
        cust_billing_salary: '0',
        budget_takehome_salary: '0',
        fixedwages_basic: '0',
        fixedwages_da: '0',
        fixedwages_hra: '0',
        fixedwages_conveyance: '0',
        fixedwages_washing: '0',
        fixedwages_other_allowance: '0',
        fixedwages_leave_wages: '0',
        fixedwages_performincentive: '0',
        fixedwages_bonus: '0',
        fixedwages_child_edu: '0',
        fixedwages_gross_salary: '0',
        worked_days: '0',
        billing_cycle_days: '0',
        ref_takehome: '0',
        ref_pt_amt: '0',
        ref_net_takehome: '0',
        remarks: '',
        created_by: config.EMP_ID,
        // sort_order (1 from employees placed facecheckin addendance, 2 from standby with vendor_emp_id,
        // 3 from standby for temp saffs with no emp id, 4 from added employee)
        sort_order: 4,
        vendor_id: config.VENDOR_ID
      }
      // this.lPayrollProcessDetList = []
      this.loadCommunity()
      this.showAddEmployeeDetailDialog = true
      this.lMAction = 'create'
    },
    closeAddEmployeeDialog () {
      this.showAddEmployeeDetailDialog = false
    },
    loadProjectForCommunity () {
      var qry = {
        params: {
          comm_id: this.lAddEmployeeDetail.comm_id
        }
      }
      this.projectList = []
      this.axios.get(config.API_URL + '/getProjectListBasedOnCommunity/', qry)
      .then(response => {
        this.projectList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    changeAddEmployeeProjectCategory () {
      this.lAddEmployeeDetail.comm_id = null
      this.lAddEmployeeDetail.proj_id = null
      this.projectList = []
    },
    saveAddEmployeeDetail (action) {
      var qry = {
        params: {
          payroll_process_base_id: this.lPayrollProcessBase.payroll_process_base_id,
          comm_id: this.lAddEmployeeDetail.comm_id,
          proj_id: this.lAddEmployeeDetail.proj_id,
          vendor_emp_id: this.lAddEmployeeDetail.vendor_emp_id,
          emp_name: this.lAddEmployeeDetail.emp_name,
          emp_desig: this.lAddEmployeeDetail.emp_desig,
          vendor_id: config.VENDOR_ID
        }
      }
      if (action === 'update' && !confirm('Sure, want to update employee details? Need to process the record once again due value change.')) {
        return
      }
      if (this.$refs.pEmpAddForm.validate()) {
        if (!this.lPayrollProcessBase.payroll_process_base_id || !this.lAddEmployeeDetail.emp_name || !this.lAddEmployeeDetail.emp_desig || !this.lAddEmployeeDetail.comm_id || !this.lAddEmployeeDetail.proj_id) {
          this.msg('Please select all mandatory fields', 0)
        } else {
          this.axios.get(config.API_URL + '/getIsEmployeeAlreadyExistsForPayrollProcess/', qry)
          .then(response => {
            if (response.data.length > 0 && action === 'create') {
              if (this.lAddEmployeeDetail.vendor_emp_id) {
                this.msg('Given Employee Id already exists for selected Month and Year : ' + this.lPayrollProcessBase.payroll_month_year, 0)
              } else {
                this.msg('Given Employee name and Designation already exists for selected Month and Year : ' + this.lPayrollProcessBase.payroll_month_year, 0)
              }
            } else {
              var empAction = ''
              if (action === 'create') {
                empAction = 'create-employee'
              } else if (action === 'update'){
                empAction = 'update-employee'
              }
              this.axios.post(config.API_URL + '/payrollProcessDetail/' + empAction, this.lAddEmployeeDetail)
              .then(response => {
                this.msg('Saved Successfully', 1)
                this.processRecord(response.data[0])
                setTimeout(() => {
                  this.loadPayrollProcessDetailList()
                  this.showAddEmployeeDetailDialog = false
                }, 500)
              })
              .catch(err => {
                this.msg(err, 0)
              })
            }
          })
        }
      }
    },
    calculateReferenceAmounts () {
      // Reference amount calculation
      this.lAddEmployeeDetail.ref_takehome = ((this.lAddEmployeeDetail.budget_takehome_salary / this.lAddEmployeeDetail.billing_cycle_days) * this.lAddEmployeeDetail.worked_days).toFixed()
      if (this.lAddEmployeeDetail.ref_takehome >= this.lPayrollProcessBase.pt_eligible_ref_amt) {
        this.lAddEmployeeDetail.ref_pt_amt = this.lPayrollProcessBase.professional_tax_amt.toFixed()
      } else {
        this.lAddEmployeeDetail.ref_pt_amt = 0
      }
      this.lAddEmployeeDetail.ref_net_takehome = (this.lAddEmployeeDetail.ref_takehome - this.lAddEmployeeDetail.ref_pt_amt).toFixed()
    },
    calculateFixedGrossAmount () {
      this.lAddEmployeeDetail.fixedwages_gross_salary = parseInt(this.lAddEmployeeDetail.fixedwages_basic) + parseInt(this.lAddEmployeeDetail.fixedwages_da) + parseInt(this.lAddEmployeeDetail.fixedwages_hra) + parseInt(this.lAddEmployeeDetail.fixedwages_conveyance) + parseInt(this.lAddEmployeeDetail.fixedwages_washing) + parseInt(this.lAddEmployeeDetail.fixedwages_other_allowance) + parseInt(this.lAddEmployeeDetail.fixedwages_leave_wages) + parseInt(this.lAddEmployeeDetail.fixedwages_performincentive) + parseInt(this.lAddEmployeeDetail.fixedwages_bonus) + parseInt(this.lAddEmployeeDetail.fixedwages_child_edu)
    },
    calculateReferenceAmountsAddEmpByEnteringManual (curType) {
      if (curType === 'ref_th') {
        if (this.lAddEmployeeDetail.ref_takehome >= this.lPayrollProcessBase.pt_eligible_ref_amt) {
          this.lAddEmployeeDetail.ref_pt_amt = this.lPayrollProcessBase.professional_tax_amt.toFixed()
        } else {
          this.lAddEmployeeDetail.ref_pt_amt = 0
        }
        this.lAddEmployeeDetail.ref_net_takehome = (parseInt(this.lAddEmployeeDetail.ref_takehome) - parseInt(this.lAddEmployeeDetail.ref_pt_amt)).toFixed()
      } else if (curType === 'ref_net_th'){
        if ((parseInt(this.lAddEmployeeDetail.ref_net_takehome) + parseInt(this.lPayrollProcessBase.professional_tax_amt)) >= this.lPayrollProcessBase.pt_eligible_ref_amt) {
          this.lAddEmployeeDetail.ref_pt_amt = this.lPayrollProcessBase.professional_tax_amt.toFixed()
        } else {
          this.lAddEmployeeDetail.ref_pt_amt = 0
        }
        this.lAddEmployeeDetail.ref_takehome = (parseInt(this.lAddEmployeeDetail.ref_net_takehome) + parseInt(this.lAddEmployeeDetail.ref_pt_amt)).toFixed()
      } else if (curType === 'pt') {
        this.lAddEmployeeDetail.ref_net_takehome = (parseInt(this.lAddEmployeeDetail.ref_takehome) - parseInt(this.lAddEmployeeDetail.ref_pt_amt)).toFixed()
      }
    },
    calculateReferenceAmountsEditByEnteringManual (curType) {
      if (curType === 'ref_th') {
        if (this.lPayrollProcessDetail.ref_takehome >= this.lPayrollProcessBase.pt_eligible_ref_amt) {
          this.lPayrollProcessDetail.ref_pt_amt = this.lPayrollProcessBase.professional_tax_amt.toFixed()
        } else {
          this.lPayrollProcessDetail.ref_pt_amt = 0
        }
        this.lPayrollProcessDetail.ref_net_takehome = (parseInt(this.lPayrollProcessDetail.ref_takehome) - parseInt(this.lPayrollProcessDetail.ref_pt_amt)).toFixed()
      } else if (curType === 'ref_net_th'){
        if ((parseInt(this.lPayrollProcessDetail.ref_net_takehome) + parseInt(this.lPayrollProcessBase.professional_tax_amt)) >= this.lPayrollProcessBase.pt_eligible_ref_amt) {
          this.lPayrollProcessDetail.ref_pt_amt = this.lPayrollProcessBase.professional_tax_amt.toFixed()
        } else {
          this.lPayrollProcessDetail.ref_pt_amt = 0
        }
        this.lPayrollProcessDetail.ref_takehome = (parseInt(this.lPayrollProcessDetail.ref_net_takehome) + parseInt(this.lPayrollProcessDetail.ref_pt_amt)).toFixed()
      } else if (curType === 'pt') {
        this.lPayrollProcessDetail.ref_net_takehome = (parseInt(this.lPayrollProcessDetail.ref_takehome) - parseInt(this.lPayrollProcessDetail.ref_pt_amt)).toFixed()
      }
    },
    async bulkPayrollProcess () {
      if (!confirm('Sure, you want to process all the records?')) {
        return
      }
      this.isProcessingPayroll = true
      const tdsBatch = []
      const pfBatch = []
      try {
        for (const rec of this.payrollProcessDetailList) {
          const processed = await this.processRecord(rec)
          if (processed) {
            if (processed.payroll_cat === 'TDS') tdsBatch.push(processed)
            else pfBatch.push(processed)
          }
        }
        if (tdsBatch.length > 0) {
          await this.axios.post(config.API_URL + '/savePayrollProcessedRecord/tds', tdsBatch)
        }
        if (pfBatch.length > 0) {
          await this.axios.post(config.API_URL + '/savePayrollProcessedRecord/pf', pfBatch)
        }
        this.msg('Payroll processed successfully', 1)
      } catch (err) {
        this.msg('Error saving payroll records: ' + err.message, 0)
      } finally {
        this.isProcessingPayroll = false
      }
    },
    async processRecord (curDetRec) {
      if (curDetRec.worked_days === 0) {
        return
      }
      var tds_tmp = 0
      var gross_salary_tmp = 0
      var professional_fee_tmp = 0
      var payroll_attendance_days = 0
      var diff_adj = 0
      var perform_incentive_tmp = 0
      var basic_tmp = 0
      var da_tmp = 0
      var hra_tmp = 0
      var conveyance_tmp = 0
      var washing_tmp = 0
      var leave_wages_tmp = 0
      var other_allowance_tmp = 0
      var adjust_amt_tmp = 0
      var bonus_tmp = 0
      var child_edu_tmp = 0
      var nfh_tmp = 0
      var ot_tmp = 0
      var esi_tmp = 0
      var pf_tmp = 0
      var pt_tmp = 0
      var tds_tmp = 0
      var tot_deduction_tmp = 0
      var net_salary_tmp = 0
      if (curDetRec.payroll_cat === 'TDS') {
        for (var i = 1; i <= this.lPayrollProcessBase.month_days; i++) {
          professional_fee_tmp = ((curDetRec.budget_takehome_salary / this.lPayrollProcessBase.month_days) * i).toFixed()
          payroll_attendance_days = i
          if (parseInt(professional_fee_tmp) > curDetRec.ref_net_takehome) {
            professional_fee_tmp = ((curDetRec.budget_takehome_salary / this.lPayrollProcessBase.month_days) * (i-1)).toFixed()
            diff_adj = curDetRec.ref_net_takehome - parseInt(professional_fee_tmp)
            curDetRec.earnedwages_other_allowance = parseInt(professional_fee_tmp).toFixed()
            curDetRec.earnedwages_adjust_amt = parseInt(diff_adj).toFixed()
            curDetRec.earnedwages_gross_salary = parseInt(curDetRec.earnedwages_other_allowance) + parseInt(curDetRec.earnedwages_adjust_amt)
            curDetRec.earnedwages_payroll_attendance = i-1
            curDetRec.tds_amount = ((parseInt(curDetRec.earnedwages_gross_salary) * this.lPayrollProcessBase.prof_ser_tds_percent) / 100).toFixed()
            curDetRec.esi_amount = parseInt(0)
            curDetRec.pf_amount = parseInt(0)
            curDetRec.pt_amount = parseInt(0)
            curDetRec.tot_deduction = parseInt(curDetRec.esi_amount) + parseInt(curDetRec.pf_amount) + parseInt(curDetRec.pt_amount) + parseInt(curDetRec.tds_amount)
            curDetRec.net_salary = parseInt(curDetRec.earnedwages_gross_salary) - parseInt(curDetRec.tot_deduction)
            return curDetRec
          }
        }
        if (parseInt(professional_fee_tmp) < curDetRec.ref_net_takehome) {
          var diff_adj = curDetRec.ref_net_takehome - parseInt(professional_fee_tmp)
          curDetRec.earnedwages_other_allowance = parseInt(professional_fee_tmp).toFixed()
          curDetRec.earnedwages_adjust_amt = parseInt(diff_adj).toFixed()
          curDetRec.earnedwages_gross_salary = parseInt(curDetRec.earnedwages_other_allowance) + parseInt(curDetRec.earnedwages_adjust_amt)
          curDetRec.earnedwages_payroll_attendance = payroll_attendance_days
          curDetRec.tds_amount = ((parseInt(curDetRec.earnedwages_gross_salary) * this.lPayrollProcessBase.prof_ser_tds_percent) / 100).toFixed()
          curDetRec.esi_amount = parseInt(0)
          curDetRec.pf_amount = parseInt(0)
          curDetRec.pt_amount = parseInt(0)
          curDetRec.tot_deduction = parseInt(curDetRec.esi_amount) + parseInt(curDetRec.pf_amount) + parseInt(curDetRec.pt_amount) + parseInt(curDetRec.tds_amount)
          curDetRec.net_salary = parseInt(curDetRec.earnedwages_gross_salary) - parseInt(curDetRec.tot_deduction)
        } else {
          curDetRec.earnedwages_other_allowance = parseInt(professional_fee_tmp).toFixed()
          curDetRec.earnedwages_adjust_amt = 0
          curDetRec.earnedwages_gross_salary = parseInt(curDetRec.earnedwages_other_allowance) + parseInt(curDetRec.earnedwages_adjust_amt)
          curDetRec.earnedwages_payroll_attendance = parseInt(payroll_attendance_days)
          curDetRec.tds_amount = ((parseInt(curDetRec.earnedwages_gross_salary) * this.lPayrollProcessBase.prof_ser_tds_percent) / 100).toFixed()
          curDetRec.esi_amount = parseInt(0)
          curDetRec.pf_amount = parseInt(0)
          curDetRec.pt_amount = parseInt(0)
          curDetRec.tot_deduction = parseInt(curDetRec.esi_amount) + parseInt(curDetRec.pf_amount) + parseInt(curDetRec.pt_amount) + parseInt(curDetRec.tds_amount)
          curDetRec.net_salary = parseInt(curDetRec.earnedwages_gross_salary) - parseInt(curDetRec.tot_deduction)
        }
        return curDetRec
      } else {
        // var temp_esi_cal = 0
        // temp_esi_cal = (curDetRec.fixedwages_gross_salary - curDetRec.fixedwages_washing - curDetRec.fixedwages_conveyance)
        for (var i = 1; i <= this.lPayrollProcessBase.month_days; i++) {
          payroll_attendance_days = i
          // console.log(i)
          basic_tmp = (curDetRec.fixedwages_basic / this.lPayrollProcessBase.month_days) * i
          da_tmp = (curDetRec.fixedwages_da / this.lPayrollProcessBase.month_days) * i
          hra_tmp = (curDetRec.fixedwages_hra / this.lPayrollProcessBase.month_days) * i
          conveyance_tmp = (curDetRec.fixedwages_conveyance / this.lPayrollProcessBase.month_days) * i
          washing_tmp = (curDetRec.fixedwages_washing / this.lPayrollProcessBase.month_days) * i
          leave_wages_tmp = (curDetRec.fixedwages_leave_wages / this.lPayrollProcessBase.month_days) * i
          other_allowance_tmp = (curDetRec.fixedwages_other_allowance / this.lPayrollProcessBase.month_days) * i
          // adjust_amt_tmp = curDetRec.earnedwages_adjust_amt ? curDetRec.earnedwages_adjust_amt : 0
          perform_incentive_tmp = (curDetRec.fixedwages_performincentive / this.lPayrollProcessBase.month_days) * i
          bonus_tmp = (curDetRec.fixedwages_bonus / this.lPayrollProcessBase.month_days) * i
          child_edu_tmp = (curDetRec.fixedwages_child_edu / this.lPayrollProcessBase.month_days) * i
          nfh_tmp = curDetRec.earnedwages_nfh ? curDetRec.earnedwages_nfh : 0
          ot_tmp = curDetRec.earnedwages_ot ? curDetRec.earnedwages_ot : 0
          gross_salary_tmp = parseInt(basic_tmp) + parseInt(da_tmp) + parseInt(hra_tmp) + parseInt(conveyance_tmp) + parseInt(washing_tmp) + parseInt(leave_wages_tmp) + parseInt(other_allowance_tmp) + parseInt(adjust_amt_tmp) + parseInt(perform_incentive_tmp) + parseInt(bonus_tmp) + parseInt(child_edu_tmp) + parseInt(nfh_tmp) + parseInt(ot_tmp)
          // ESI Calculation
          if (curDetRec.is_esi_opted) {
            esi_tmp = (((parseInt(basic_tmp) + parseInt(da_tmp)) * this.lPayrollProcessBase.ESI_percent_employee)/100).toFixed()
          } else {
            esi_tmp = 0
          }
          // PF Calculation
          if (curDetRec.is_pf_opted) {
            pf_tmp = (((parseInt(basic_tmp) + parseInt(da_tmp)) * this.lPayrollProcessBase.PF_percent_employee)/100).toFixed()
            if (pf_tmp >= this.lPayrollProcessBase.PF_restrict_limit_employee) {
              pf_tmp = this.lPayrollProcessBase.PF_restrict_limit_employee
            }
          } else {
            pf_tmp = 0
          }
          // PT Calculation
          if (parseInt(gross_salary_tmp) >= this.lPayrollProcessBase.pt_limit_amt) {
            pt_tmp = parseInt(this.lPayrollProcessBase.professional_tax_amt)
          } else {
            pt_tmp = parseInt(0)
          }
          // TDS Calculation
          tds_tmp = parseInt(0)
          tot_deduction_tmp = parseInt(esi_tmp) + parseInt(pf_tmp) + parseInt(pt_tmp) + parseInt(tds_tmp)
          net_salary_tmp = parseInt(gross_salary_tmp) - parseInt(tot_deduction_tmp)
          if (parseInt(net_salary_tmp) > curDetRec.ref_net_takehome) {
            var j = (i-1)
            payroll_attendance_days = j
            basic_tmp = (curDetRec.fixedwages_basic / this.lPayrollProcessBase.month_days) * j
            da_tmp = (curDetRec.fixedwages_da / this.lPayrollProcessBase.month_days) * j
            hra_tmp = (curDetRec.fixedwages_hra / this.lPayrollProcessBase.month_days) * j
            conveyance_tmp = (curDetRec.fixedwages_conveyance / this.lPayrollProcessBase.month_days) * j
            washing_tmp = (curDetRec.fixedwages_washing / this.lPayrollProcessBase.month_days) * j
            leave_wages_tmp = (curDetRec.fixedwages_leave_wages / this.lPayrollProcessBase.month_days) * j
            other_allowance_tmp = (curDetRec.fixedwages_other_allowance / this.lPayrollProcessBase.month_days) * j
            // adjust_amt_tmp = curDetRec.earnedwages_adjust_amt ? curDetRec.earnedwages_adjust_amt : 0
            perform_incentive_tmp = (curDetRec.fixedwages_performincentive / this.lPayrollProcessBase.month_days) * j
            bonus_tmp = (curDetRec.fixedwages_bonus / this.lPayrollProcessBase.month_days) * j
            child_edu_tmp = (curDetRec.fixedwages_child_edu / this.lPayrollProcessBase.month_days) * j
            nfh_tmp = curDetRec.earnedwages_nfh ? curDetRec.earnedwages_nfh : 0
            ot_tmp = curDetRec.earnedwages_ot ? curDetRec.earnedwages_ot : 0
            gross_salary_tmp = parseInt(basic_tmp) + parseInt(da_tmp) + parseInt(hra_tmp) + parseInt(conveyance_tmp) + parseInt(washing_tmp) + parseInt(leave_wages_tmp) + parseInt(other_allowance_tmp) + parseInt(adjust_amt_tmp) + parseInt(perform_incentive_tmp) + parseInt(bonus_tmp) + parseInt(child_edu_tmp) + parseInt(nfh_tmp) + parseInt(ot_tmp)
            // ESI Calculation
            if (curDetRec.is_esi_opted) {
              esi_tmp = (((parseInt(basic_tmp) + parseInt(da_tmp)) * this.lPayrollProcessBase.ESI_percent_employee)/100).toFixed()
            } else {
              esi_tmp = 0
            }
            // PF Calculation
            if (curDetRec.is_pf_opted) {
              pf_tmp = (((parseInt(basic_tmp) + parseInt(da_tmp)) * this.lPayrollProcessBase.PF_percent_employee)/100).toFixed()
              if (pf_tmp >= this.lPayrollProcessBase.PF_restrict_limit_employee) {
                pf_tmp = this.lPayrollProcessBase.PF_restrict_limit_employee
              }
            } else {
              pf_tmp = 0
            }
            // PT Calculation
            if (parseInt(gross_salary_tmp) >= this.lPayrollProcessBase.pt_limit_amt) {
              pt_tmp = parseInt(this.lPayrollProcessBase.professional_tax_amt)
            } else {
              pt_tmp = parseInt(0)
            }
            // TDS Calculation
            tds_tmp = parseInt(0)
            tot_deduction_tmp = parseInt(esi_tmp) + parseInt(pf_tmp) + parseInt(pt_tmp) + parseInt(tds_tmp)
            net_salary_tmp = parseInt(gross_salary_tmp) - parseInt(tot_deduction_tmp)

            // based on adjustment amt gross salary and net salary will be calculated again.
            adjust_amt_tmp = curDetRec.ref_net_takehome - parseInt(net_salary_tmp)
            gross_salary_tmp = parseInt(basic_tmp) + parseInt(da_tmp) + parseInt(hra_tmp) + parseInt(conveyance_tmp) + parseInt(washing_tmp) + parseInt(leave_wages_tmp) + parseInt(other_allowance_tmp) + parseInt(adjust_amt_tmp) + parseInt(perform_incentive_tmp) + parseInt(bonus_tmp) + parseInt(child_edu_tmp) + parseInt(nfh_tmp) + parseInt(ot_tmp)
            if (curDetRec.is_esi_opted) {
              esi_tmp = (((parseInt(basic_tmp) + parseInt(da_tmp)) * this.lPayrollProcessBase.ESI_percent_employee)/100).toFixed()
            } else {
              esi_tmp = 0
            }
            tot_deduction_tmp = parseInt(esi_tmp) + parseInt(pf_tmp) + parseInt(pt_tmp) + parseInt(tds_tmp)
            net_salary_tmp = parseInt(gross_salary_tmp) - parseInt(tot_deduction_tmp)

            if (parseInt(net_salary_tmp) < curDetRec.ref_net_takehome) {
              // based on adjustment amt gross salary and net salary will be calculated again.
              adjust_amt_tmp = adjust_amt_tmp + curDetRec.ref_net_takehome - parseInt(net_salary_tmp)
              gross_salary_tmp = parseInt(basic_tmp) + parseInt(da_tmp) + parseInt(hra_tmp) + parseInt(conveyance_tmp) + parseInt(washing_tmp) + parseInt(leave_wages_tmp) + parseInt(other_allowance_tmp) + parseInt(adjust_amt_tmp) + parseInt(perform_incentive_tmp) + parseInt(bonus_tmp) + parseInt(child_edu_tmp) + parseInt(nfh_tmp) + parseInt(ot_tmp)
              if (curDetRec.is_esi_opted) {
                esi_tmp = (((parseInt(basic_tmp) + parseInt(da_tmp)) * this.lPayrollProcessBase.ESI_percent_employee)/100).toFixed()
              } else {
                esi_tmp = 0
              }
              tot_deduction_tmp = parseInt(esi_tmp) + parseInt(pf_tmp) + parseInt(pt_tmp) + parseInt(tds_tmp)
              net_salary_tmp = parseInt(gross_salary_tmp) - parseInt(tot_deduction_tmp)
            }

            var expect_yearly_bonus_tmp = 0
            if(curDetRec.fixedwages_bonus === 0) {
              var expect_yearly_bonus_tmp = ((curDetRec.earnedwages_basic + curDetRec.earnedwages_da) * 8.33)/100
            }

            curDetRec.earnedwages_payroll_attendance = payroll_attendance_days
            curDetRec.earnedwages_basic = parseInt(basic_tmp).toFixed()
            curDetRec.earnedwages_da = parseInt(da_tmp).toFixed()
            curDetRec.earnedwages_hra = parseInt(hra_tmp).toFixed()
            curDetRec.earnedwages_conveyance = parseInt(conveyance_tmp).toFixed()
            curDetRec.earnedwages_washing = parseInt(washing_tmp).toFixed()
            curDetRec.earnedwages_other_allowance = parseInt(other_allowance_tmp).toFixed()
            curDetRec.earnedwages_leave_wages = parseInt(leave_wages_tmp).toFixed()
            curDetRec.earnedwages_performincentive = parseInt(perform_incentive_tmp).toFixed()
            curDetRec.earnedwages_bonus = parseInt(bonus_tmp).toFixed()
            curDetRec.earnedwages_child_edu = parseInt(child_edu_tmp).toFixed()
            curDetRec.earnedwages_adjust_amt = parseInt(adjust_amt_tmp).toFixed()
            curDetRec.earnedwages_nfh = parseInt(nfh_tmp).toFixed()
            curDetRec.earnedwages_ot = parseInt(ot_tmp).toFixed()
            curDetRec.earnedwages_gross_salary = parseInt(gross_salary_tmp).toFixed()

            curDetRec.expect_yearly_bonus = parseInt(expect_yearly_bonus_tmp).toFixed()

            curDetRec.esi_amount = parseInt(esi_tmp).toFixed()
            curDetRec.pf_amount = parseInt(pf_tmp).toFixed()
            curDetRec.pt_amount = parseInt(pt_tmp).toFixed()
            curDetRec.tds_amount = parseInt(tds_tmp).toFixed()
            curDetRec.tot_deduction = parseInt(tot_deduction_tmp).toFixed()
            curDetRec.net_salary = parseInt(net_salary_tmp).toFixed()

            // console.log('vvvvvvvv - ' + curDetRec.emp_name)
            return curDetRec
          }
        }
        // month days loop completed and still amount not exceeded
        if (parseInt(net_salary_tmp) < curDetRec.ref_net_takehome) {
          // based on adjustment amt gross salary and net salary will be calculated again.
          adjust_amt_tmp = parseInt(curDetRec.ref_net_takehome).toFixed() - parseInt(net_salary_tmp).toFixed()
          gross_salary_tmp = parseInt(basic_tmp) + parseInt(da_tmp) + parseInt(hra_tmp) + parseInt(conveyance_tmp) + parseInt(washing_tmp) + parseInt(leave_wages_tmp) + parseInt(other_allowance_tmp) + parseInt(adjust_amt_tmp) + parseInt(perform_incentive_tmp) + parseInt(bonus_tmp) + parseInt(child_edu_tmp) + parseInt(nfh_tmp) + parseInt(ot_tmp)
          if (curDetRec.is_esi_opted) {
            esi_tmp = (((parseInt(basic_tmp) + parseInt(da_tmp)) * this.lPayrollProcessBase.ESI_percent_employee)/100).toFixed()
          } else {
            esi_tmp = 0
          }
          tot_deduction_tmp = parseInt(esi_tmp) + parseInt(pf_tmp) + parseInt(pt_tmp) + parseInt(tds_tmp)
          net_salary_tmp = parseInt(gross_salary_tmp) - parseInt(tot_deduction_tmp)

          if (parseInt(net_salary_tmp) < curDetRec.ref_net_takehome) {
            // based on adjustment amt gross salary and net salary will be calculated again.
            adjust_amt_tmp = adjust_amt_tmp + parseInt(curDetRec.ref_net_takehome) - parseInt(net_salary_tmp).toFixed()
            gross_salary_tmp = parseInt(basic_tmp) + parseInt(da_tmp) + parseInt(hra_tmp) + parseInt(conveyance_tmp) + parseInt(washing_tmp) + parseInt(leave_wages_tmp) + parseInt(other_allowance_tmp) + parseInt(adjust_amt_tmp) + parseInt(perform_incentive_tmp) + parseInt(bonus_tmp) + parseInt(child_edu_tmp) + parseInt(nfh_tmp) + parseInt(ot_tmp)
            if (curDetRec.is_esi_opted) {
              esi_tmp = (((parseInt(basic_tmp) + parseInt(da_tmp)) * this.lPayrollProcessBase.ESI_percent_employee)/100).toFixed()
            } else {
              esi_tmp = 0
            }
            tot_deduction_tmp = parseInt(esi_tmp) + parseInt(pf_tmp) + parseInt(pt_tmp) + parseInt(tds_tmp)
            net_salary_tmp = parseInt(gross_salary_tmp).toFixed() - parseInt(tot_deduction_tmp).toFixed()
          }

          var expect_yearly_bonus_tmp = 0
          if(curDetRec.fixedwages_bonus === 0) {
            var expect_yearly_bonus_tmp = ((curDetRec.earnedwages_basic + curDetRec.earnedwages_da) * 8.33)/100
          }

          curDetRec.earnedwages_payroll_attendance = payroll_attendance_days
          curDetRec.earnedwages_basic = parseInt(basic_tmp).toFixed()
          curDetRec.earnedwages_da = parseInt(da_tmp).toFixed()
          curDetRec.earnedwages_hra = parseInt(hra_tmp).toFixed()
          curDetRec.earnedwages_conveyance = parseInt(conveyance_tmp).toFixed()
          curDetRec.earnedwages_washing = parseInt(washing_tmp).toFixed()
          curDetRec.earnedwages_other_allowance = parseInt(other_allowance_tmp).toFixed()
          curDetRec.earnedwages_leave_wages = parseInt(leave_wages_tmp).toFixed()
          curDetRec.earnedwages_performincentive = parseInt(perform_incentive_tmp).toFixed()
          curDetRec.earnedwages_bonus = parseInt(bonus_tmp).toFixed()
          curDetRec.earnedwages_child_edu = parseInt(child_edu_tmp).toFixed()
          curDetRec.earnedwages_adjust_amt = parseInt(adjust_amt_tmp).toFixed()
          curDetRec.earnedwages_nfh = parseInt(nfh_tmp).toFixed()
          curDetRec.earnedwages_ot = parseInt(ot_tmp).toFixed()
          curDetRec.earnedwages_gross_salary = parseInt(gross_salary_tmp).toFixed()

          curDetRec.expect_yearly_bonus = parseInt(expect_yearly_bonus_tmp).toFixed()

          curDetRec.esi_amount = parseInt(esi_tmp).toFixed()
          curDetRec.pf_amount = parseInt(pf_tmp).toFixed()
          curDetRec.pt_amount = parseInt(pt_tmp).toFixed()
          curDetRec.tds_amount = parseInt(tds_tmp).toFixed()
          curDetRec.tot_deduction = parseInt(tot_deduction_tmp).toFixed()
          curDetRec.net_salary = parseInt(net_salary_tmp).toFixed()
          // console.log('worked more days - ' + curDetRec.emp_name)
          return curDetRec
        } else {

          var expect_yearly_bonus_tmp = 0
          if(curDetRec.fixedwages_bonus === 0) {
            var expect_yearly_bonus_tmp = ((curDetRec.earnedwages_basic + curDetRec.earnedwages_da) * 8.33)/100
          }

          adjust_amt_tmp = parseInt(curDetRec.ref_net_takehome).toFixed() - parseInt(net_salary_tmp).toFixed()
          curDetRec.earnedwages_payroll_attendance = payroll_attendance_days
          curDetRec.earnedwages_basic = parseInt(basic_tmp).toFixed()
          curDetRec.earnedwages_da = parseInt(da_tmp).toFixed()
          curDetRec.earnedwages_hra = parseInt(hra_tmp).toFixed()
          curDetRec.earnedwages_conveyance = parseInt(conveyance_tmp).toFixed()
          curDetRec.earnedwages_washing = parseInt(washing_tmp).toFixed()
          curDetRec.earnedwages_other_allowance = parseInt(other_allowance_tmp).toFixed()
          curDetRec.earnedwages_leave_wages = parseInt(leave_wages_tmp).toFixed()
          curDetRec.earnedwages_performincentive = parseInt(perform_incentive_tmp).toFixed()
          curDetRec.earnedwages_bonus = parseInt(bonus_tmp).toFixed()
          curDetRec.earnedwages_child_edu = parseInt(child_edu_tmp).toFixed()
          curDetRec.earnedwages_adjust_amt = parseInt(adjust_amt_tmp).toFixed()
          curDetRec.earnedwages_nfh = parseInt(nfh_tmp).toFixed()
          curDetRec.earnedwages_ot = parseInt(ot_tmp).toFixed()
          curDetRec.earnedwages_gross_salary = parseInt(gross_salary_tmp).toFixed()

          curDetRec.expect_yearly_bonus = parseInt(expect_yearly_bonus_tmp).toFixed()

          curDetRec.esi_amount = parseInt(esi_tmp).toFixed()
          curDetRec.pf_amount = parseInt(pf_tmp).toFixed()
          curDetRec.pt_amount = parseInt(pt_tmp).toFixed()
          curDetRec.tds_amount = parseInt(tds_tmp).toFixed()
          curDetRec.tot_deduction = parseInt(tot_deduction_tmp).toFixed()
          curDetRec.net_salary = parseInt(net_salary_tmp).toFixed()
          // console.log('worked equal days - ' + curDetRec.emp_name)
          return curDetRec
        }
      }
    },
    preparePayrollProcessStatus (curBase, status) {
      this.lPayrollProcessStatus = Object.assign({}, curBase)
      this.lPayrollProcessStatus.approve_remarks = ''
      this.lPayrollProcessStatus.submit_remarks = ''
      this.lPayrollProcessStatus.rejected_remark = ''
      this.lPayrollProcessStatus.drafted_remarks = ''
      this.lPayrollProcessStatus.status = status
      this.showCommentDlg = true
    },
    loadCompareBillingandSalaryForBaseIdDetails (curBase) {
      this.showCompareDlg = true
      var qry = {
        params: {
          billing_month: curBase.payrollMonth,
          billing_year: curBase.payrollYear,
          payroll_process_base_id: curBase.payroll_process_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.compareBillingSalaryDet = []
      this.axios.get(config.API_URL + '/getCompareBillingandPayrollProcessSalary/', qry)
      .then(response => {
        this.compareBillingSalaryDet = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    statusChangeTheProjectContract (curBase, status) {
      var idx = -1
      if (status === "Submitted") {
        idx = this.payrollProcessVersionList.findIndex(rec => rec.base_status === status)
      }
      if (idx > -1) {
        this.msg('Only one Submitted version is allowed for one Project Contract', 0)
      } else {
        if (!confirm('Sure, you want to change the Status to "' + status + ' ?"')) {
          return
        }
        // up in db
        curBase.vendor_id = config.VENDOR_ID
        curBase.status = status
        if (status === 'Submitted') {
          curBase.submitted_by = config.EMP_ID
          curBase.approved_by = null
          curBase.approved_date = null
        } else if (status === 'Approved') {
          curBase.approved_by = config.EMP_ID
        } else if (status === "Draft") {
          curBase.drafted_by = config.EMP_ID
        } else {
          curBase.rejected_by = config.EMP_ID
        }
        curBase.payroll_process_base_id = this.lPayrollProcessBase.payroll_process_base_id
        this.axios.post(config.API_URL + '/payrollProcessBase/status', curBase)
        .then(response => {
          // this.lProjContractDet.action = 'View'
          if (status === "Rejected") {
            this.lPayrollProcessBase.base_status = "Draft"
          } else {
            this.lPayrollProcessBase.base_status = status
          }
          this.loadPayrollProcessVersionsList()
          this.changePayrollProcessVersionList()
          this.loadPayrollProcessDetailList()
          this.lAction = 'update'
          this.msg('Saved Successfully', 1)
          this.showCommentDlg = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    prepareRevision (curRec) {
      var qry = {
        params: {
          payroll_month_year: curRec.payroll_month_year,
          vendor_id: config.VENDOR_ID
        }
      }

      this.axios.get(config.API_URL + '/getIsDraftOrSubmittedVersionExistsForPayrollMonthYear/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.msg('Draft / Submitted version "' + response.data[0].base_status + ' (v' + response.data[0].base_version + '.0)" already exists. Use existing version to make changes', 0)
        } else {
          curRec.emp_id = config.EMP_ID
          this.axios.post(config.API_URL + '/payrollProcessCreateRevision/createrevision', curRec)
          .then(response => {
            this.lPayrollProcessBase = Object.assign({}, response.data)
            this.lPayrollProcessBase.updated_by = config.EMP_ID
            this.loadPayrollProcessVersionsList()
            this.loadPayrollProcessDetailList()
            this.lAction = 'update'
          })
          .catch(err => {
            this.msg(err, 0)
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
  }
}
</script>

<style lang="scss">
.importtabletd.v-data-table td{
  font-weight:normal;
  font-size:12px !important;
}
.importtableth.v-data-table th{
  font-weight:bold;
  font-size:12px !important;
}
.my-label-text-size .v-label {
  font-size: 12px !important;
}
</style>
